// zakazky_plocha_v1 (20. 10. 2026): karta zákazky — tenšia hlavička, Info po sekciách
// sekcie_v3 (20. 10. 2026, ústava 61.10): Výdavky zákazky — sivé telo, Náklady zákazky ako Sekcia, skupiny dokladov ako karty
// vzhlad_predajne_v2 (20. 10. 2026, ústava 61.10): starý oranžový panel/akcent nahradený hodnotami témy — 1 miest
// ProjectDetail / DetailPane — Matrix v2 Task #8 MVP
// Tabs: Info (✅) / ChangeOrder (✅ sek. 32) / Audit (✅) + placeholdery (Výmery/VV/Súpis/Denník/FA/Náklady)
//
// Pre master-detail v ZakazkyView (embeddable, bez breadcrumb)

import { NovyKontaktPartnera, usePartnerKontakty, OsobaBunky, bunkyOsoby, FUNKCIE } from '../components/KontaktyPartnera.jsx'   // ústava 131.10 + 0.J (p93)
import TelefonInput from '../components/TelefonInput.jsx'   // KONTAKTY_STAVBY_V1
import React, { useState, useEffect, useMemo, useRef } from 'react'
import { fetchAuthJSON, fetchAuth } from '../auth/fetchAuth.js'
import FotkyZakazky from './FotkyZakazky.jsx'
import TerminyZakazky, { TerminyAkciaOkno } from '../components/TerminyZakazky.jsx'
import RdZiskovost, { useRdZiskovost } from '../components/RdZiskovost.jsx'
import KreditVyspravky from '../components/KreditVyspravky.jsx'   // VYSPRAVKY_V1: výmera na výplatu partiám + kredit na výspravky
import { MksoftStavKarty } from '../components/ParovanieMKsoft.jsx'   // párovanie s MKsoftom (27. 9. 2026)   // 122.7 náklady pred vyúčtovaním RD + priebežný zisk (27. 9. 2026)   // 23.2.A začiatok a koniec ručne (25. 9. 2026)
import VydavokBezDokladuModal from '../components/VydavokBezDokladuModal.jsx'   // 13. 9. 2026 (bod 6)
import { normPhone } from '../utils/phone.js'
import { useAuth } from '../auth/AuthContext.jsx'
import { Btn, BtnNav, BtnAdd, BtnDanger, BtnGhost } from '../components/Btn.jsx'
import { Modal } from '../components/Modal.jsx'
import RowMenu from '../components/RowMenu.jsx'
import { Input, NumberInput, Textarea } from '../components/Input.jsx'
import { Table, THead, TBody, TR, TH, TD } from '../components/Table.jsx'
import { useToast } from '../components/Toast.jsx'
import { useConfirm } from '../components/ConfirmDialog.jsx'   // cena_v2 (30. 9. 2026): dôvod opravy pýtame v okne Matrixu, nie cez okienko prehliadača
import { usePinGate } from '../hooks/usePinGate.jsx'
import { useDirtyState, useDirtyFlag } from '../hooks/useDirtyState.js'   // straz_v1: useDirtyFlag pre J.C. zákazky
import { COLORS, TYPO, SPACE, RADIUS, SK } from '../theme.js'
import { Tabs, Sekcia, SearchableSelect } from '../components/Ui.jsx'   // sekcie_v3 · KONTAKTY_STAVBY_V2: výber firmy a osoby
import VymeryView from './VymeryView.jsx'
import VyuctovanieRD from './VyuctovanieRD.jsx'
import ReklamacieView from './ReklamacieView.jsx'
import SupisTab from './SupisTab.jsx'
import VVTab from './VVTab.jsx'
import MzdyTab from './MzdyTab.jsx'
import HarmonogramTab from './HarmonogramTab.jsx'
import DokumentyTab from './DokumentyTab.jsx'
import NavIcon from '../components/NavIcon.jsx'
import SpisTab from './SpisTab.jsx'
import AttachmentsPanel from '../components/AttachmentsPanel.jsx'
import { useLock } from '../hooks/useLock.js'
import { confirmLeave } from '../hooks/unsavedGuard.js'
import ErrorBoundary from '../components/ErrorBoundary.jsx'
import HistoryPanel from '../components/HistoryPanel.jsx'   // hist_menu_v1: kto čo zmenil na karte zákazky (audit_log module 'zakazka', ústava 3.S.1)
import PrijmyTab, { PrijmyInfo } from '../components/PrijmyZakazky.jsx'   // PRIJMY_ZAKAZKA_V1 (27. 10. 2026, Kronika matrix 3680–3702): Info blok + karta Príjmy
import StavbaTab from './StavbaTab.jsx'   // stavba_v1 (28. 9. 2026): podmienky a pripravenosť stavby + kontaktné osoby protistrany (Kronika 913 body 1–2, pre-flight v2 C6)

const TL = (icon, text) => <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5 }}><NavIcon name={icon} size={14} />{text}</span>
const TABS = [
  { key: 'info',         label: 'Info',              active: true },
  { key: 'vydavky',      label: 'Výdavky',           active: true },   // sek. 9.A HIGH 1, sek. 22, sek. 29
  { key: 'prijmy',       label: 'Príjmy',            active: true },   // PRIJMY_ZAKAZKA_V1: vystavené FA, zádržné, zápočty, zrážky (výdavky aj príjmy vedľa seba)
  { key: 'audit',        label: 'História',          active: true },   // hist_menu_v1: slovník 66.6 C; obsah = história záznamu + kto čo zmenil (3.S.1 bod 3)
  { key: 'fotky',        label: TL('fotky', 'Fotky'),  active: true },   // sek. 59 — PRED/PO foto-prílohy
  { key: 'zod',          label: TL('zod', 'ZoD & zmluvy'), active: true },   // Mirko nahráva (nevytvára) — sek. 25
  // BETA — implementacia ako vlastne tasky
  { key: 'rozpis',       label: 'Rozpis',            active: false },
  { key: 'vymery',       label: TL('vymery', 'Výmery'), active: true },
  { key: 'vv',           label: 'VV',                active: true },
  { key: 'harmonogram',  label: 'Harmonogram',       active: true },   // Gantt z Vymer (ustava HARMONOGRAM PRE-FLIGHT 2026-06-10)
  { key: 'supis',        label: 'Súpis',             active: true },
  { key: 'mzdy',         label: 'Mzdy',              active: true },
  { key: 'dokumenty',    label: TL('doks', 'Dokumenty'), active: true },
  { key: 'spis',        label: TL('spis', 'Spis'),    active: true },
  { key: 'zavady',       label: TL('zavady', 'Závady'), active: true },   // sek. 96.10 — piny na PD, spoločná štruktúra s OMERAJ
  { key: 'reklamacie',   label: 'Reklamácie',        active: true },
  { key: 'stavba',       label: 'Stavba',            active: true },   // stavba_v1: podmienky a pripravenosť stavby, kontaktné osoby protistrany (C6)
  { key: 'dennik',       label: 'Denník',            active: false },
  { key: 'fa',           label: 'FA',                active: false },
  { key: 'changeorder',  label: 'Zmenové príkazy',   active: false }   // sek. 32 — odlozene na po-beta, beta zakazky sa kodom zmazu
]

const STATUS_LABEL = {
  planned: { icon: '', label: 'Dohodnuté', color: '#0369a1' },
  active:  { icon: '', label: 'Prebieha',  color: '#15803d' },
  done:    { icon: '', label: 'Ukončené',  color: '#dc2626' }
}

export function DetailPane({ id, custMap = {}, onReload, onEdit }) {
  const [project, setProject] = useState(null)
  const [loading, setLoading] = useState(true)
  const [tab, setTab] = useState(() => { try { return sessionStorage.getItem('matrix:projtab:' + id) || 'info' } catch(_) { return 'info' } })
  const [vyuctMoze, setVyuctMoze] = useState(false)   // VYUCTOVANIE_FIRMA_V1: bez VV = vyúčtovanie (RD aj firma), s VV = súpis (Mirko 20. 10. 2026)
  useEffect(() => { let on = true; setVyuctMoze(false); if (id) fetchAuth(`/api/dodacie-listy/moze/${encodeURIComponent(id)}`).then(r => r.ok ? r.json() : null).then(j => { if (on) setVyuctMoze(!!(j && j.moze)) }).catch(() => {}); return () => { on = false } }, [id])
  const [vyuctOpen, setVyuctOpen] = useState(false)   // vyúčtovanie RD (ústava 122)
  const _prevTabId = useRef(id)
  useEffect(() => { if (_prevTabId.current !== id) { _prevTabId.current = id; try { setTab(sessionStorage.getItem('matrix:projtab:' + id) || 'info') } catch(_) { setTab('info') } } }, [id])
  useEffect(() => { try { sessionStorage.setItem('matrix:projtab:' + id, tab) } catch(_) {} }, [tab, id])
  const toast = useToast()

  const reload = () => {
    setLoading(true)
    fetchAuthJSON(`/api/projects/${id}`)
      .then(p => setProject(p))
      .catch(e => toast.error(`Načítanie zákazky ${id} zlyhalo: ${e.message}`))
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    if (!id) return
    reload()
  }, [id])

  if (loading) {
    return <DetailWrap>Načítavam {id}…</DetailWrap>
  }
  if (!project) {
    return <DetailWrap color={COLORS.remove}>Zákazka {id} sa nenašla.</DetailWrap>
  }

  const st = STATUS_LABEL[project.status] || STATUS_LABEL.planned

  return (
    <div style={{
      background: COLORS.bg,
      border: `1px solid ${COLORS.line}`,
      borderRadius: RADIUS.lg,
      padding: SPACE.md,   // zakazky_plocha_v1: tenšia hlavička karty
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden'
    }}>
      {/* HLAVICKA */}
      <div style={{ height: 3, background: COLORS.brand, margin: `-${SPACE.md}px -${SPACE.md}px ${SPACE.sm}px` }} />
      <div style={{ display: 'flex', alignItems: 'center', gap: SPACE.md, flexWrap: 'wrap', marginBottom: SPACE.xs }}>
        <h2 style={{ margin: 0, fontSize: TYPO.sizes.lg, fontWeight: TYPO.weights.extra, color: COLORS.base }}>{project.name}</h2>
        <span style={{ color: COLORS.muted, fontFamily: TYPO.mono, fontSize: TYPO.sizes.sm }}>{project.id}</span>
        {project.zakazka_code && (
          <span style={{ color: COLORS.muted, fontSize: TYPO.sizes.sm }}>· {project.zakazka_code}</span>
        )}
        <span style={{
          padding: '2px 8px',
          fontSize: TYPO.sizes.xs,
          fontWeight: TYPO.weights.semibold,
          color: st.color,
          background: `${st.color}15`,
          border: `1px solid ${st.color}`,
          borderRadius: RADIUS.full
        }}>{st.label}</span>
        <span style={{ flex: 1 }} />
        {vyuctMoze && (
          <BtnNav onClick={() => setVyuctOpen(true)} title="Dodací list s cenou — zákazník schváli pred faktúrou (zákazka bez výkazu výmer, RD aj firma; ústava 122)">Vyúčtovanie</BtnNav>
        )}
        {onEdit && (
          <BtnNav onClick={() => onEdit(project)} title="Upraviť (alebo 2× klik v zozname / Enter)">Upraviť</BtnNav>
        )}
      </div>

      {/* TABS */}
      <Tabs tabs={TABS} value={tab} onChange={(t) => { confirmLeave().then(ok => { if (ok) setTab(t) }) }} />
      {vyuctOpen && <VyuctovanieRD project={project} onClose={() => setVyuctOpen(false)} />}

      {/* TAB CONTENT — biela karta na oranžovom paneli (ústava 61.7) */}
      {/* sekcie_v3 (ústava 61.10): Výdavky majú sivé telo a časti ako biele karty; ostatné záložky zatiaľ biele (prechod po jednej) */}
      <div style={{ flex: 1, overflow: 'auto', background: (tab === 'vydavky' || tab === 'info') ? COLORS.page : COLORS.bg,   // zakazky_plocha_v1: aj Info po sekciách
        border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.lg, padding: SPACE.md }}>
        <ErrorBoundary key={tab} label={(TABS.find(t => t.key === tab) || {}).label || tab}>
        {tab === 'info' && <InfoTab project={project} custMap={custMap} onZmena={() => { reload(); onReload && onReload() }} onPrijmy={() => setTab('prijmy')} />}
        {tab === 'vydavky' && <VydavkyTab project={project} />}
        {tab === 'prijmy' && <PrijmyTab projectId={project.id} />}
        {tab === 'audit' && <AuditTab project={project} onParentReload={onReload} />}
        {tab === 'fotky' && <FotkyTab project={project} />}
        {tab === 'zod' && <ZodTab project={project} />}
        {tab === 'changeorder' && <ChangeOrderTab project={project} onProjectReload={reload} onParentReload={onReload} />}
        {tab === 'vymery' && <VymeryView projectId={project.id} remesla={project.type || project.remesla} />}{/* SUPIS_JEDNOTNE_V1 */}
        {tab === 'vv' && <VVTab projectId={project.id} />}
        {tab === 'supis' && <SupisTab projectId={project.id} />}
        {tab === 'harmonogram' && <HarmonogramTab projectId={project.id} />}
        {tab === 'mzdy' && <MzdyTab projectId={project.id} />}
        {tab === 'dokumenty' && <DokumentyTab projectId={project.id} />}
        {tab === 'reklamacie' && <ReklamacieView projectId={project.id} embedded />}
        {tab === 'stavba' && <StavbaTab project={project} />}
        {tab === 'zavady' && (() => { const cu = window.location.protocol === 'https:' ? 'https://control.ksbx.sk' : ('http://' + window.location.hostname + ':8092');
          const bigUrl = cu + '/?project_id=' + encodeURIComponent(project.id) + '&from=matrix&token=' + encodeURIComponent(localStorage.getItem('kamir_token') || '');
          return <div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 6 }}>
              <button onClick={() => window.open(bigUrl, '_blank')} title='Otvorí Závady (CONTROL) na celú obrazovku v novom okne'
                style={{ padding: '7px 14px', borderRadius: 8, border: '1px solid #0369a1', background: '#0369a1', color: '#fff', fontWeight: 700, fontSize: 13, cursor: 'pointer' }}>Otvoriť veľké okno</button>
            </div>
            <iframe src={cu + '/?embed=1&project_id=' + encodeURIComponent(project.id)} title='Závady (CONTROL)'
              onLoad={e => { try { e.target.contentWindow.postMessage({ type: 'kamir-token', token: localStorage.getItem('kamir_token') || '', project: { id: project.id, name: project.name, zakazka_code: project.zakazka_code || '' } }, cu); } catch (_) {} }}
              style={{ width: '100%', height: 'calc(100vh - 200px)', minHeight: 560, border: 'none', display: 'block', borderRadius: 8 }} />
          </div>; })()}
        {tab === 'spis' && <SpisTab projectId={project.id} />}
        </ErrorBoundary>
      </div>
    </div>
  )
}

// ── DetailWrap (loading / error) ───────────────────────────────
function DetailWrap({ children, color }) {
  return (
    <div style={{
      background: COLORS.bg,
      border: `1px solid ${COLORS.line}`,
      borderRadius: RADIUS.lg,
      padding: SPACE.xl,
      height: '100%',
      color: color || COLORS.muted
    }}>{children}</div>
  )
}

// ══════════════════════════════════════════════════════════════
// INFO TAB
// ══════════════════════════════════════════════════════════════
// Finančný prehľad do Info karty (Mirko 2026-06-29): Výdaje · Fakturácia · osobitne Mzdy
function FinanceWidget({ projectId, segment }) {
  const [d, setD] = useState(null)
  const [vyuMoze, setVyuMoze] = useState(false)   // VYUCTOVANIE_FIRMA_V1
  useEffect(() => { let on = true; fetchAuth(`/api/dodacie-listy/moze/${encodeURIComponent(projectId)}`).then(r => r.ok ? r.json() : null).then(j => { if (on) setVyuMoze(!!(j && j.moze)) }).catch(() => {}); return () => { on = false } }, [projectId])
  const vyuBlok = vyuMoze || segment === 'rd'
  const [rz, nacitajRz] = useRdZiskovost(projectId, vyuBlok)
  const [err, setErr] = useState(false)
  useEffect(() => {
    let on = true
    fetchAuth(`/api/projects/${encodeURIComponent(projectId)}/finance`)
      .then(r => r.ok ? r.json() : Promise.reject(new Error()))
      .then(j => { if (on) setD(j) })
      .catch(() => { if (on) setErr(true) })
    return () => { on = false }
  }, [projectId])
  if (err) return null
  const eur = (n) => SK.eur(n || 0)
  const Card = ({ icon, label, value, color, sub }) => (
    <div style={{ flex: 1, minWidth: 150, background: COLORS.bg, border: `1px solid ${COLORS.line}`, borderTop: `3px solid ${color}`, borderRadius: RADIUS.md, padding: '8px 12px' }}>
      <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, fontWeight: TYPO.weights.semibold }}>{icon} {label}</div>
      <div style={{ fontSize: 19, fontWeight: TYPO.weights.bold, fontFamily: TYPO.mono, marginTop: 3, color }}>{d ? eur(value) : '…'}</div>
      {d && sub ? <div style={{ fontSize: 10, color: COLORS.muted, marginTop: 4, lineHeight: 1.5 }}>{sub}</div> : null}
    </div>
  )
  return (
    <div style={{ marginBottom: SPACE.md }}>
      <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, fontWeight: TYPO.weights.semibold, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 6 }}>Finančný prehľad</div>
      <div style={{ display: 'flex', gap: SPACE.sm, flexWrap: 'wrap' }}>
        <Card icon="" label={rz && rz.zisk && rz.zisk.prijem_zdroj === 'vyuctovanie' ? 'Príjem — vyúčtovanie (bez DPH)' : 'Fakturácia (vystavené)'} color={COLORS.add} value={d && d.fakturacia}
          sub={d && d.fakturacia_detail ? `MKsoft ${eur(d.fakturacia_detail.mksoft)} · Matrix ${eur(d.fakturacia_detail.matrix)}${d.fakturacia_detail.zrazky ? ` · mínus zrážky za nedorobky ${eur(d.fakturacia_detail.zrazky)}` : ''}${d.fakturacia_detail.mksoft_ceka && d.fakturacia_detail.mksoft_ceka.count ? ` · nezapočítané, čaká na potvrdenie: ${d.fakturacia_detail.mksoft_ceka.count} ks za ${eur(d.fakturacia_detail.mksoft_ceka.amount)} (karta Príjmy)` : ''}` : null} />
        <Card icon="" label="Výdaje — bez DPH (materiál + došlé FA)" color={COLORS.brand} value={d && d.vydaje}
          sub={d && d.vydaje_detail ? `došlé FA ${eur(d.vydaje_detail.dosleFa)} · VSZAK ${eur(d.vydaje_detail.vszak)} · VSOST ${eur(d.vydaje_detail.vsost)}${d.vydaje_detail.nepotvrdene && d.vydaje_detail.nepotvrdene.count ? ` · nezapočítané, čaká na určenie v Došlých FA: ${d.vydaje_detail.nepotvrdene.count} ks za ${eur(d.vydaje_detail.nepotvrdene.amount)}` : ''}${d.vydaje_detail.evidencne && d.vydaje_detail.evidencne.count ? ` · evidenčné doklady (sklad, nie náklad): ${d.vydaje_detail.evidencne.count} ks za ${eur(d.vydaje_detail.evidencne.amount)}` : ''}` : null} />
        <Card icon="" label="Mzdy" color={COLORS.info} value={d && d.mzdy}
          sub={d && d.mzdy_detail ? `zošit Mzdy 2026 ${eur(d.mzdy_detail.zosit)}${d.mzdy_detail.nafta ? ' (z toho nafta partiám ' + eur(d.mzdy_detail.nafta) + ')' : ''}${d.mzdy_detail.archiv ? ' · archív do 30.6. ' + eur(d.mzdy_detail.archiv) : ''} · cez SZČO ${eur(d.mzdy_detail.szco)}${d.mzdy_detail.szco_kanal ? ` · SZČO FA ako výplata nároku ${eur(d.mzdy_detail.szco_kanal)} (nepripočítané)` : ''}` : null} />
        <Card icon="" label="Priebežný zisk" color={(rz ? rz.zisk.zisk : (d ? d.zisk : 0)) >= 0 ? '#15803d' : COLORS.remove} value={rz ? rz.zisk.zisk : (d && d.zisk)}
          sub={rz ? `${rz.zisk.prijem_zdroj === 'vyuctovanie' ? 'vyúčtované ' : 'fakturácia '}${eur(rz.zisk.prijem)} − mzdy ${eur(rz.zisk.mzdy)} − materiál ${eur(rz.zisk.material)}` : d ? `príjem ${eur(d.fakturacia)} − náklady ${eur(d.naklady_spolu)}` : null} />
      </div>
      {vyuBlok && <RdZiskovost projectId={projectId} rz={rz} nacitaj={nacitajRz} />}
      {d && (
        <div style={{ display: 'flex', gap: SPACE.md, flexWrap: 'wrap', marginTop: 6, fontSize: TYPO.sizes.xs, color: COLORS.muted }}>
          <span>Náklady spolu (výdaje + mzdy): <b style={{ color: COLORS.text }}>{eur(d.naklady_spolu)}</b></span>
          {d.fakturacia ? <span>Rozdiel príjem − náklady: <b style={{ color: (d.fakturacia - d.naklady_spolu) >= 0 ? COLORS.add : COLORS.remove }}>{eur(d.fakturacia - d.naklady_spolu)}</b></span> : null}
          {d.pending && d.pending.count > 0 ? <span style={{ color: '#9a3412' }}>čaká na potvrdenie: {d.pending.count} ({eur(d.pending.amount)}) — zatiaľ sa neráta</span> : null}
        </div>
      )}
    </div>
  )
}

// ústava 131.10 + 0.J (p93): kontaktné osoby partnera zo SPOLOČNÉHO registra — tie isté ako v dopyte, obhliadke,
// kalkulácii, ponuke, objednávke aj v SMS. Nová osoba sa zakladá priamo do registra.
// KONTAKTY_STAVBY_V1 (Mirko 21. 10. 2026: „ako viem editovať kontakty?? ak uz napr. nerobí musí byt možnost odobrať zo stavby,
// nie z kontaktov, ak sa mu zmení funkcia na stavbe???“). Hore osoby TEJTO stavby — väzba zakazka_kontakty, tá istá ako v záložke
// Stavba (0.J): Upraviť kontakt mení register Kontakty (platí všade), Zmeniť funkciu na stavbe platí len pre túto zákazku,
// Odobrať zo stavby archivuje väzbu a osoba v Kontaktoch ostáva. Pod nimi sivé osoby partnera, ktoré na stavbe nie sú.
const FUNKCIE_STAVBY = ['stavbyvedúci', 'rozpočtár', 'pripravár', 'technik', 'technik na potery', 'majster', 'investor', 'generálny dodávateľ', 'projektový manažér', 'TDI', 'kontaktná osoba na stavbe']
const PILULKA = { padding: '2px 9px', fontSize: 12, borderRadius: 12, background: 'transparent', fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }
async function volajKontakty(u, opts) {
  const r = await fetchAuth(u, { headers: { 'Content-Type': 'application/json' }, ...(opts || {}) })
  const j = await r.json().catch(() => ({}))
  if (!r.ok) throw new Error(j.error || 'Uloženie zlyhalo')
  return j
}
function KontaktyZakazky({ projectId, customerId }) {
  const toast = useToast()
  const opytajSa = useConfirm()
  const { rows, pridaj } = usePartnerKontakty(customerId)
  const [naStavbe, setNaStavbe] = useState(null)
  const [novy, setNovy] = useState(false)
  const [uprav, setUprav] = useState(null)   // { typ: 'kontakt' | 'funkcia', id, v }
  const [busy, setBusy] = useState(false)
  const [predtym, setPredtym] = useState([])          // KONTAKTY_STAVBY_V2: odobratí zo stavby (história)
  const [ukazPredtym, setUkazPredtym] = useState(false)
  const [inaFirma, setInaFirma] = useState(null)      // KONTAKTY_STAVBY_V2: osoba inej firmy (napr. stavbyvedúci GD) z celých Kontaktov
  const [partneri, setPartneri] = useState(null)
  const url = '/api/stavba/' + encodeURIComponent(projectId || '') + '/kontakty'
  const nacitaj = React.useCallback(() => {
    fetchAuth(url).then(r => (r.ok ? r.json() : [])).then(d => setNaStavbe(Array.isArray(d) ? d : [])).catch(() => setNaStavbe([]))
    fetchAuth(url + '-predtym').then(r => (r.ok ? r.json() : [])).then(d => setPredtym(Array.isArray(d) ? d : [])).catch(() => {})
  }, [url])
  useEffect(() => { if (projectId) nacitaj() }, [projectId, nacitaj])
  if (!customerId && !projectId) return '—'
  const odkaz = { color: '#0369a1', textDecoration: 'none', fontWeight: 400 }
  const sivo = { color: '#64748b', fontWeight: 400 }
  const inp = { padding: '5px 8px', fontSize: TYPO.sizes.sm, border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.sm, fontFamily: 'inherit', boxSizing: 'border-box', width: '100%', background: '#fff', color: COLORS.text, fontWeight: 400 }
  const lbl = { display: 'flex', flexDirection: 'column', gap: 2, fontSize: TYPO.sizes.xs, color: COLORS.muted, fontWeight: 400, minWidth: 0 }
  const naIds = new Set((naStavbe || []).map(k => k.kontakt_id))
  const mimo = naStavbe ? rows.filter(k => !naIds.has(k.id) && !k.odisiel_at) : []
  const naStavbu = async (k) => { const j = await volajKontakty(url, { method: 'POST', body: JSON.stringify({ kontakt_id: k.id, rola: k.funkcia || '' }) }); setNaStavbe(j.kontakty); return j }
  const pridajJedneho = async (k) => {
    if (busy) return
    setBusy(true)
    try { await naStavbu(k); toast.success((k.meno || k.email) + ' je na stavbe') } catch (e) { toast.error(e.message) } finally { setBusy(false) }
  }
  const pridajVsetkych = async () => {
    if (busy) return
    setBusy(true)
    try { for (const k of mimo) await naStavbu(k); toast.success('Na stavbe: ' + mimo.length + ' osôb partnera') } catch (e) { toast.error(e.message); nacitaj() } finally { setBusy(false) }
  }
  const odober = async (k) => {
    const ok = await opytajSa({ title: 'Odobrať zo stavby?', message: (k.meno || k.email || '') + ' — odoberie sa len z tejto zákazky, v Kontaktoch partnera ostáva.', confirmLabel: 'Odobrať zo stavby', danger: true })
    if (!ok) return
    try { const j = await volajKontakty(url + '/' + k.id + '/archive', { method: 'POST', body: '{}' }); setNaStavbe(j.kontakty); nacitaj(); toast.success((k.meno || k.email) + ' odobratý zo stavby — v Kontaktoch ostáva') } catch (e) { toast.error(e.message) }
  }
  const ulozFunkciu = async () => {
    const rola = String(uprav.v.rola || '').trim()
    if (!rola) { toast.error('Zadaj funkciu na stavbe'); return }
    setBusy(true)
    try { const j = await volajKontakty(url + '/' + uprav.id, { method: 'PUT', body: JSON.stringify({ rola }) }); setNaStavbe(j.kontakty); setUprav(null); toast.success('Funkcia na stavbe: ' + rola) } catch (e) { toast.error(e.message) } finally { setBusy(false) }
  }
  const ulozKontakt = async () => {
    const v = uprav.v
    if (!String(v.first_name || '').trim() || !String(v.last_name || '').trim()) { toast.error('Zadaj meno aj priezvisko kontaktu'); return }
    if (!String(v.email || '').trim() && !String(v.telefon || '').trim()) { toast.error('Zadaj e-mail alebo telefón'); return }
    setBusy(true)
    try {
      const row = await volajKontakty('/api/partner-contacts/' + encodeURIComponent(uprav.id), { method: 'PUT', body: JSON.stringify({ titul: String(v.titul || '').trim(), first_name: v.first_name.trim(), last_name: v.last_name.trim(), funkcia: String(v.funkcia || '').trim(), email: String(v.email || '').trim(), telefon: String(v.telefon || '').trim() }) })
      if (String(row.customer_id) === String(customerId)) pridaj(row)
      setUprav(null); nacitaj(); toast.success('Kontakt upravený — platí všade v Matrixe')
    } catch (e) { toast.error(e.message) } finally { setBusy(false) }
  }
  // KONTAKTY_STAVBY_V2: osoba prešla do inej firmy — starý kontakt ostane pri starej firme ako „odišiel“, na tejto stavbe podľa voľby
  const zmenaFirmy = (k) => {
    setUprav({ typ: 'firma', id: k.kontakt_id, vazba: k.id, rola: k.rola || '', v: { customer_id: '', funkcia: k.funkcia || '', email: '', telefon: k.telefon || '', ostava: true } })
    if (!partneri) fetchAuth('/api/customers').then(r => (r.ok ? r.json() : [])).then(d => setPartneri(Array.isArray(d) ? d.filter(c => !c.kos_at) : [])).catch(() => setPartneri([]))
  }
  const ulozFirmu = async () => {
    const v = uprav.v
    if (!v.customer_id) { toast.error('Vyber novú firmu'); return }
    if (!String(v.email || '').trim() && !String(v.telefon || '').trim()) { toast.error('Zadaj nový e-mail alebo telefón'); return }
    setBusy(true)
    try {
      const j = await volajKontakty('/api/partner-contacts/' + encodeURIComponent(uprav.id) + '/zmena-firmy', { method: 'POST', body: JSON.stringify({ customer_id: v.customer_id, funkcia: String(v.funkcia || '').trim(), email: String(v.email || '').trim(), telefon: String(v.telefon || '').trim() }) })
      if (j.stary && String(j.stary.customer_id) === String(customerId)) pridaj(j.stary)
      if (v.ostava) {
        await volajKontakty(url + '/' + uprav.vazba + '/archive', { method: 'POST', body: '{}' })
        await volajKontakty(url, { method: 'POST', body: JSON.stringify({ kontakt_id: j.novy.id, rola: uprav.rola }) })
      }
      setUprav(null); nacitaj()
      toast.success((j.novy.meno || j.novy.email) + ' prešiel do ' + j.firma + (v.ostava ? ' — na stavbe ostáva za novú firmu' : ''))
    } catch (e) { toast.error(e.message); nacitaj() } finally { setBusy(false) }
  }
  const otvorInuFirmu = () => {
    setInaFirma([])
    fetchAuth('/api/partner-contacts?vsetky=1').then(r => (r.ok ? r.json() : [])).then(d => setInaFirma(Array.isArray(d) ? d.filter(x => !x.odisiel_at) : [])).catch(() => setInaFirma([]))
  }
  const setV = (k, x) => setUprav(u => ({ ...u, v: { ...u.v, [k]: x } }))
  const tlacidla = (uloz) => (
    <div style={{ display: 'flex', gap: 6 }}>
      <BtnAdd size="sm" disabled={busy} onClick={uloz}>{busy ? 'Ukladám…' : 'Uložiť'}</BtnAdd>
      <BtnGhost size="sm" onClick={() => setUprav(null)}>Zrušiť</BtnGhost>
    </div>
  )
  const ramik = { marginTop: 4, padding: 8, border: `1px dashed ${COLORS.line}`, borderRadius: RADIUS.sm, background: COLORS.bgSoft || '#f8fafc', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: 6, alignItems: 'end' }
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
      {naStavbe === null && <span style={sivo}>Načítavam…</span>}
      {naStavbe && naStavbe.length === 0 && <span style={sivo}>na stavbe zatiaľ nikto — pridaj osoby partnera nižšie</span>}
      {(naStavbe || []).map(k => (
        <div key={k.id}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <span style={{ flex: 1, minWidth: 0 }}>
              {k.meno || k.email}<span style={sivo}>{', ' + (k.rola || k.funkcia || '')}</span>
              {k.telefon ? <> · <a href={'tel:' + String(k.telefon).replace(/\s/g, '')} style={odkaz}>{k.telefon}</a></> : null}
              {k.email ? <> · <a href={'mailto:' + k.email} style={odkaz}>{k.email}</a></> : null}
              {k.partner && String(k.customer_id) !== String(customerId) ? <span style={sivo}>{' · ' + k.partner}</span> : null}
              {k.odisiel_at ? <span style={{ color: '#b45309', fontWeight: 600 }}>{' · odišiel' + (k.nastupca_firma ? ' do ' + k.nastupca_firma : '')}</span> : null}
            </span>
            <RowMenu compact actions={[
              { key: 'kontakt', label: 'Upraviť kontakt', onClick: () => setUprav({ typ: 'kontakt', id: k.kontakt_id, v: { ...bunkyOsoby(k), funkcia: k.funkcia || '', email: k.email || '', telefon: k.telefon || '' } }) },
              { key: 'funkcia', label: 'Zmeniť funkciu na stavbe', onClick: () => setUprav({ typ: 'funkcia', id: k.id, v: { rola: k.rola || '' } }) },
              { separator: true },
              { key: 'odober', label: 'Odobrať zo stavby', danger: true, onClick: () => odober(k) },
            ]} />
          </div>
          {uprav && uprav.typ === 'funkcia' && uprav.id === k.id && (
            <div style={ramik}>
              <label style={lbl}>Funkcia na tejto stavbe<input autoFocus list="funkcie-stavby" value={uprav.v.rola} onChange={e => setV('rola', e.target.value)} onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); ulozFunkciu() } }} style={inp} /></label>
              <datalist id="funkcie-stavby">{FUNKCIE_STAVBY.map(x => <option key={x} value={x} />)}</datalist>
              {tlacidla(ulozFunkciu)}
            </div>
          )}
          {uprav && uprav.typ === 'kontakt' && uprav.id === k.kontakt_id && (
            <div style={ramik}>
              <OsobaBunky v={uprav.v} set={setV} lbl={lbl} inp={inp} autoFocus />
              <label style={lbl}>Funkcia (všade)<input list="funkcie-kontaktu-zak" value={uprav.v.funkcia} onChange={e => setV('funkcia', e.target.value)} style={inp} /></label>
              <datalist id="funkcie-kontaktu-zak">{FUNKCIE.map(x => <option key={x} value={x} />)}</datalist>
              <label style={lbl}>E-mail<input type="email" value={uprav.v.email} onChange={e => setV('email', e.target.value)} style={inp} /></label>
              <label style={lbl}>Telefón<TelefonInput value={uprav.v.telefon} onChange={x => setV('telefon', x)} style={inp} /></label>
              {tlacidla(ulozKontakt)}
              <button type="button" onClick={() => zmenaFirmy(k)} style={{ ...PILULKA, alignSelf: 'center', border: `1px solid ${COLORS.line}`, color: COLORS.text }}>Zmenil firmu…</button>
            </div>
          )}
          {uprav && uprav.typ === 'firma' && uprav.vazba === k.id && (
            <div style={ramik}>
              <div style={{ gridColumn: '1 / -1', fontSize: 12, color: COLORS.muted, fontWeight: 400 }}>{(k.meno || k.email) + ' prechádza do inej firmy. Pri ' + (k.partner || 'pôvodnej firme') + ' ostane ako „odišiel“ — staré stavby a odoslané doklady sa nemenia.'}</div>
              <label style={{ ...lbl, gridColumn: '1 / -1' }}>Nová firma
                <SearchableSelect value={uprav.v.customer_id} onChange={x => setV('customer_id', String(x || ''))} menuPortal placeholder={partneri ? 'Vyber firmu z Partnerov…' : 'Načítavam Partnerov…'}
                  options={(partneri || []).filter(c => String(c.id) !== String(k.customer_id)).map(c => ({ value: String(c.id), label: c.name + (c.ico ? ' · IČO ' + c.ico : '') }))} />
              </label>
              <label style={lbl}>Funkcia v novej firme<input list="funkcie-kontaktu-zak" value={uprav.v.funkcia} onChange={e => setV('funkcia', e.target.value)} style={inp} /></label>
              <datalist id="funkcie-kontaktu-zak">{FUNKCIE.map(x => <option key={x} value={x} />)}</datalist>
              <label style={lbl}>Nový e-mail<input type="email" value={uprav.v.email} onChange={e => setV('email', e.target.value)} style={inp} /></label>
              <label style={lbl}>Telefón<TelefonInput value={uprav.v.telefon} onChange={x => setV('telefon', x)} style={inp} /></label>
              <label style={{ ...lbl, gridColumn: '1 / -1', flexDirection: 'row', alignItems: 'center', gap: 6, color: COLORS.text, fontSize: TYPO.sizes.sm }}>
                <input type="checkbox" checked={!!uprav.v.ostava} onChange={e => setV('ostava', e.target.checked)} /> Na tejto stavbe ostáva — za novú firmu
              </label>
              {tlacidla(ulozFirmu)}
            </div>
          )}
        </div>
      ))}
      {mimo.length > 0 && (
        <div style={{ marginTop: 4, display: 'flex', alignItems: 'center', gap: 8, ...sivo, fontSize: 12 }}>
          <span>Osoby partnera, ktoré na stavbe nie sú:</span>
          {mimo.length > 1 && <button type="button" disabled={busy} onClick={pridajVsetkych} style={{ ...PILULKA, border: `1px solid ${COLORS.line}`, color: COLORS.text }}>Pridať všetkých na stavbu</button>}
        </div>
      )}
      {mimo.map(k => (
        <div key={k.id} style={{ display: 'flex', alignItems: 'center', gap: 6, ...sivo }}>
          <span style={{ flex: 1, minWidth: 0 }}>{k.meno || k.email}{k.funkcia ? ', ' + k.funkcia : ''}{k.telefon ? ' · ' + k.telefon : ''}{k.email ? ' · ' + k.email : ''}</span>
          <button type="button" disabled={busy} onClick={() => pridajJedneho(k)} style={{ ...PILULKA, border: '1px solid #15803d', color: '#15803d' }}>+ na stavbu</button>
        </div>
      ))}
      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginTop: 2 }}>
        {customerId && (
          <button type="button" onClick={() => setNovy(v => !v)} style={{ ...PILULKA, border: '1px dashed #15803d', color: '#15803d' }}>
            {novy ? 'Zavrieť' : '+ Nová osoba partnera'}
          </button>
        )}
        {projectId && !inaFirma && <button type="button" onClick={otvorInuFirmu} style={{ ...PILULKA, border: `1px dashed ${COLORS.line}`, color: COLORS.text }}>+ osoba inej firmy</button>}
      </div>
      {inaFirma && (
        <div style={ramik}>
          <label style={{ ...lbl, gridColumn: '1 / -1' }}>Osoba z Kontaktov — aj inej firmy (napr. stavbyvedúci generálneho dodávateľa)
            <SearchableSelect value="" menuPortal placeholder="Hľadať meno, firmu, e-mail…"
              onChange={x => { const o = inaFirma.find(c => String(c.id) === String(x)); if (o) { setInaFirma(null); pridajJedneho(o) } }}
              options={inaFirma.filter(c => !naIds.has(c.id)).map(c => ({ value: String(c.id), label: (c.meno || c.email) + (c.customer_name ? ' · ' + c.customer_name : '') + (c.funkcia ? ' · ' + c.funkcia : '') }))} />
          </label>
          <div><BtnGhost size="sm" onClick={() => setInaFirma(null)}>Zrušiť</BtnGhost></div>
        </div>
      )}
      {predtym.length > 0 && (
        <div style={{ marginTop: 2, ...sivo, fontSize: 12 }}>
          <button type="button" onClick={() => setUkazPredtym(v => !v)} style={{ background: 'none', border: 'none', padding: 0, color: COLORS.muted, cursor: 'pointer', fontFamily: 'inherit', fontSize: 12, textDecoration: 'underline' }}>Predtým na stavbe ({predtym.length})</button>
          {ukazPredtym && predtym.map(p => (
            <div key={p.id}>{(p.meno || '—') + (p.rola ? ', ' + p.rola : '') + (p.partner ? ' · ' + p.partner : '') + ' · do ' + SK.datumCas(p.zmenene_at) + (p.zmenil_meno ? ' · odobral ' + p.zmenil_meno : '')}</div>
          ))}
        </div>
      )}
      {novy && <NovyKontaktPartnera customerId={customerId} onUlozene={async row => { pridaj(row); setNovy(false); if (projectId && row && row.id && !naIds.has(row.id)) { try { await naStavbu(row) } catch (e) { toast.error(e.message) } } }} onZrus={() => setNovy(false)} />}
    </div>
  )
}

// ── J.C. ZÁKAZKY PO REMESLÁCH (p98; Mirko 21. 9. 2026: „každá zákazka musí mať widget, kde je J.C. za omietky,
// maľby a potery. Zadá sa buď zo ZoD, alebo ručne pri otvorení zákazky."). Návrh = hlavná položka remesla vo VV zákazky
// (VV = rozpočet zo ZoD, ústava 1116); ručné zadanie ho prepíše. Widget informuje, nič neblokuje (ústava 0.W).
function JcZakazky({ projectId }) {
  const toast = useToast()
  const [d, setD] = useState(null)
  const [uprava, setUprava] = useState(null)
  const [busy, setBusy] = useState(false)
  const ulozRef = useRef(null)   // straz_v1: rozpísaná úprava J.C. drží stráž odchodu (ústava 53.1)
  useDirtyFlag(!!uprava, { key: 'jc-zakazky', save: () => (ulozRef.current ? ulozRef.current() : false), discard: () => setUprava(null) })
  const nacitaj = () => fetchAuth('/api/projects/' + encodeURIComponent(projectId) + '/jc').then(r => (r.ok ? r.json() : null)).then(x => setD(x)).catch(() => {})
  useEffect(() => { nacitaj() }, [projectId])   // eslint-disable-line react-hooks/exhaustive-deps
  if (!d) return null
  const R = [['omietka', 'Omietky'], ['malba', 'Maľby'], ['poter', 'Potery']]
  const f2 = (n) => Number(n).toLocaleString('sk-SK', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
  const ulozene = d.ulozene || {}
  const navrh = d.navrh || {}
  const zacni = () => {
    const u = {}
    for (const [k] of R) { u[k] = ulozene[k] && ulozene[k].jc != null ? String(ulozene[k].jc) : ''; u['z_' + k] = (ulozene[k] && ulozene[k].zdroj) || 'rucne' }
    setUprava(u)
  }
  const uloz = async () => {
    setBusy(true)
    try {
      const telo = {}
      for (const [k] of R) telo[k] = String(uprava[k] || '').trim() === '' ? null : { jc: uprava[k], zdroj: uprava['z_' + k] }
      const r = await fetchAuth('/api/projects/' + encodeURIComponent(projectId) + '/jc', { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(telo) })
      const j = await r.json().catch(() => ({}))
      if (!r.ok) throw new Error(j.error || 'Uloženie zlyhalo.')
      setUprava(null); await nacitaj(); toast.success('J.C. zákazky uložené.'); return true
    } catch (e) { toast.error(e.message); return false } finally { setBusy(false) }
  }
  ulozRef.current = uloz
  const karta = { flex: '1 1 150px', border: `1px solid ${COLORS.line}`, borderRadius: 8, padding: '8px 10px', minWidth: 0 }
  const pole = { width: '100%', padding: '5px 8px', border: `1px solid ${COLORS.line}`, borderRadius: 6, fontFamily: 'inherit', fontSize: 13, boxSizing: 'border-box', textAlign: 'right' }
  const tlac = { padding: '3px 10px', border: `1px solid ${COLORS.line}`, background: '#fff', borderRadius: 6, cursor: 'pointer', fontFamily: 'inherit', fontSize: 12 }
  return (
    <div style={{ margin: '10px 0 12px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6, flexWrap: 'wrap' }}>
        <b style={{ fontSize: 13 }}>J.C. zákazky</b>
        <span style={{ fontSize: 12, color: COLORS.muted }}>€/m² za omietky, maľby a potery — zo ZoD (VV zákazky) alebo zadané ručne</span>
        <span style={{ flex: 1 }} />
        {d.smiem && !uprava && <button type="button" onClick={zacni} style={tlac}>Upraviť</button>}
        {uprava && <>
          <button type="button" onClick={() => setUprava(null)} style={tlac}>Zrušiť</button>
          <button type="button" onClick={uloz} disabled={busy} style={{ ...tlac, background: COLORS.add, color: '#fff', border: `1px solid ${COLORS.add}`, fontWeight: 700 }}>{busy ? 'Ukladám…' : 'Uložiť'}</button>
        </>}
      </div>
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
        {R.map(([k, l]) => {
          const u = ulozene[k], n = navrh[k]
          const jc = u && u.jc != null ? Number(u.jc) : (n ? n.jc : null)
          const zdroj = u && u.jc != null ? (u.zdroj === 'vv' ? 'zo ZoD (VV)' : 'zadané ručne') + (u.kto ? ' · ' + u.kto : '') : (n ? 'návrh zo ZoD (VV)' : '')
          return (
            <div key={k} style={karta}>
              <div style={{ fontSize: 12, color: COLORS.muted }}>{l}</div>
              {uprava ? (
                <>
                  <input value={uprava[k]} inputMode="decimal" placeholder={n ? f2(n.jc) : '€/m²'} style={pole}
                    onChange={e => { const v = e.target.value; setUprava(s => ({ ...s, [k]: v, ['z_' + k]: 'rucne' })) }} />
                  {n && <button type="button" style={{ ...tlac, marginTop: 4, fontSize: 11 }} title={n.popis}
                    onClick={() => setUprava(s => ({ ...s, [k]: String(n.jc), ['z_' + k]: 'vv' }))}>Prevziať zo ZoD: {f2(n.jc)} €</button>}
                </>
              ) : (
                <>
                  <div style={{ fontSize: 18, fontWeight: 800, color: jc != null ? COLORS.text : COLORS.muted, fontVariantNumeric: 'tabular-nums' }}>{jc != null ? f2(jc) + ' €/m²' : '—'}</div>
                  <div style={{ fontSize: 11, color: COLORS.muted }} title={n ? 'Hlavná položka vo VV: ' + n.popis + ' (' + f2(n.m2) + ' m²)' : ''}>{zdroj || 'nezadané'}</div>
                </>
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}

// anhydrit_office_v1 (Mirko 18. 10. 2026, Kronika 1657): pod Financnym prehladom MENSIE dlazdice 'Podla vykazu vymer' za celu zakazku —
// len polozky s potvrdenym mnozstvom (+ pocet bez potvrdenia), Spolu EUR len s pravom (66.9). Zdroj: rekapPotery (GET /api/vymery-stav/:id/rekap),
// ziadny novy vypocet (0.J). Zakazka bez poterovych vymer: rad sa neukaze.
function VvMiniWidget({ projectId }) {
  const [r, setR] = useState(null)
  useEffect(() => {
    let on = true
    fetchAuth('/api/vymery-stav/' + encodeURIComponent(projectId) + '/rekap?remeslo=potery').then(x => x.ok ? x.json() : null).then(j => { if (on) setR(j) }).catch(() => {})
    return () => { on = false }
  }, [projectId])
  if (!r || !Array.isArray(r.polozky) || !r.polozky.length || !(r.celkom && r.celkom.miestnosti > 0)) return null
  const f1 = n => (Number(n) || 0).toFixed(1).replace('.', ',')
  const nazov = p => p.druh === 'anhydrit' ? 'Anhydrit ' + p.hrubka + ' mm' + (p.kurenie ? ' · kúr.' : '') : p.druh === 'vrstvy' ? 'Izolácia ' + p.vrstvy + '×' : p.druh === 'folia' ? 'PE fólia' : p.druh === 'parozabrana' ? 'Parozábrana' : p.druh === 'cement' ? 'Cementový poter' : 'Dilatačný pás'   // POTER_CEMENT_V1
  const farba = p => p.druh === 'anhydrit' ? COLORS.info : p.druh === 'vrstvy' ? COLORS.add : COLORS.muted
  const nenulove = r.polozky.filter(p => p.potvrdene > 0), skryte = r.polozky.length - nenulove.length
  return (
    <div style={{ marginTop: -4, marginBottom: SPACE.sm }}>
      <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, fontWeight: TYPO.weights.semibold, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 6 }}>Podľa výkazu výmer — potery (potvrdené kanceláriou)</div>
      <div style={{ display: 'flex', gap: SPACE.sm, flexWrap: 'wrap' }}>
        {nenulove.map((p, i) => <div key={i} title={p.popis} style={{ flex: '0 1 150px', minWidth: 130, background: COLORS.bg, border: `1px solid ${COLORS.line}`, borderLeft: `3px solid ${farba(p)}`, borderRadius: RADIUS.md, padding: '6px 10px' }}>
          <div style={{ fontSize: 10, color: COLORS.muted, fontWeight: TYPO.weights.semibold, textTransform: 'uppercase', letterSpacing: '0.05em' }}>{nazov(p)}</div>
          <div style={{ fontSize: 14, fontWeight: TYPO.weights.bold, fontFamily: TYPO.mono, marginTop: 2 }}>{f1(p.potvrdene)} <span style={{ fontSize: 10, color: COLORS.muted, fontWeight: 400 }}>/ {f1(p.vo_vv)} {p.mj}</span></div>
          {p.navrh > 0 ? <div style={{ fontSize: 10, color: '#9a3412' }}>zo stavby čaká {f1(p.navrh)}</div> : null}
        </div>)}
        {r.s_cenami ? <div style={{ flex: '0 1 170px', minWidth: 150, background: COLORS.bg, border: `1px solid ${COLORS.line}`, borderLeft: `3px solid ${COLORS.brand}`, borderRadius: RADIUS.md, padding: '6px 10px' }}>
          <div style={{ fontSize: 10, color: COLORS.muted, fontWeight: TYPO.weights.semibold, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Spolu potvrdené</div>
          <div style={{ fontSize: 14, fontWeight: TYPO.weights.bold, fontFamily: TYPO.mono, marginTop: 2, color: COLORS.brand }}>{SK.eur(r.celkom.eur_potvrdene || 0)} <span style={{ fontSize: 10, color: COLORS.muted, fontWeight: 400 }}>/ VV {SK.eur(r.celkom.eur_vv || 0)}</span></div>
        </div> : null}
        {!nenulove.length ? <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, alignSelf: 'center' }}>zatiaľ nič potvrdené</div> : null}
      </div>
      {skryte > 0 ? <div style={{ fontSize: 10, color: COLORS.muted, marginTop: 4 }}>+ {skryte} položiek výkazu zatiaľ bez potvrdenia · pokládka a anhydrit sa vedú vo Výmerách → poter</div> : null}
    </div>
  )
}

function InfoTab({ project, custMap, onZmena, onPrijmy }) {
  const rows = [
    ['Zákazník',       project.customer_name || custMap[project.customerId] || '—'],
    ['E-mail zák.',    project.customer_email || '—'],
    ['Telefón zák.',   project.customer_phone ? normPhone(project.customer_phone) : '—'],
    ['Kontaktné osoby', <KontaktyZakazky projectId={project.id} customerId={project.customerId || project.customer_id} />],
    ['Segment',        project.segment === 'rd' ? 'RD (rodinný dom)' : 'Firma'],
    ['Fakturácia',     project.fakturacia === 'opakujuca' ? 'Opakujúca (priebežná)' : project.fakturacia === 'jednorazova' ? 'Jednorázová' : '— nevybrané (doplň v úprave)'],
    ['Čo robíme',      project.remesla ? project.remesla.split(',').map(r => r === 'maliarske' ? 'maľby' : r).join(', ') + (project.remesla.includes(',') && project.type ? ' · hlavné ' + project.type : '') : (project.type || '—')],   // SUPIS_JEDNOTNE_V1
    ['ZoD číslo',      project.contract_ref || '—'],
    ['Dátum ZoD',      project.contract_date || '—'],
    ['Hodnota ZoD',    project.zmluva_hodnota ? SK.eur(project.zmluva_hodnota) : '—'],
    ['Majster',        project.majster || '—'],
    ['Adresa stavby',  project.site_address || '—'],
    ['MKsoft č.',      <MksoftStavKarty project={project} onChanged={onZmena} />]
    // Začiatok, Koniec, Odovzdané → blok Termíny (23.2.A)
  ]

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: SPACE.md }}>
      {/* zakazky_plocha_v1 (ústava 61.10): Info po sekciách — každá časť je biela karta na sivom tele */}
      <Sekcia ploche style={{ marginBottom: 0 }}>
      <FinanceWidget projectId={project.id} segment={project.segment} />
      <VvMiniWidget projectId={project.id} />{/* anhydrit_office_v1 (1657) */}
      <JcZakazky projectId={project.id} />
      </Sekcia>
      <Sekcia ploche style={{ marginBottom: 0 }}><PrijmyInfo projectId={project.id} onOtvor={onPrijmy} onZmena={onZmena} />{/* ZAKAZKA_CISLA_V1: zmena čísla obnoví kartu */}</Sekcia>{/* PRIJMY_ZAKAZKA_V1 */}
      <div style={{ background: COLORS.bg, borderRadius: RADIUS.lg }}><TerminyZakazky project={project} onChanged={onZmena} /></div>
      <Sekcia nazov="Údaje zákazky" style={{ marginBottom: 0 }}>
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: TYPO.sizes.sm }}>
        <tbody>
          {rows.map(([k, v]) => (
            <tr key={k} style={{ borderBottom: `1px solid ${COLORS.lineSoft}` }}>
              <td style={{ padding: '6px 8px', color: COLORS.muted, width: 180 }}>{k}</td>
              <td style={{ padding: '6px 8px', fontWeight: TYPO.weights.semibold }}>{v}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {project.google_maps_link && (
        <div>
          <a href={project.google_maps_link} target="_blank" rel="noopener noreferrer"
            style={{
              display: 'inline-flex', alignItems: 'center', gap: 6, padding: '6px 12px',
              background: COLORS.navBg, color: COLORS.nav, border: `1px solid ${COLORS.nav}`,
              borderRadius: RADIUS.md, textDecoration: 'none', fontSize: TYPO.sizes.sm,
              fontWeight: TYPO.weights.semibold
            }}>Otvoriť v Mapách</a>
        </div>
      )}
      </Sekcia>

      {project.notes && (
        <Sekcia nazov="Poznámka" style={{ marginBottom: 0 }}>
          <div style={{ fontSize: TYPO.sizes.sm, whiteSpace: 'pre-wrap' }}>{project.notes}</div>
        </Sekcia>
      )}

      <LoanedMachinesPanel projectId={project.id} />
    </div>
  )
}

// Pozicovna stroje priradene na tuto zakazku (P3, Mirko 2026-06-10)
function LoanedMachinesPanel({ projectId }) {
  const [loans, setLoans] = useState([])
  const [loaded, setLoaded] = useState(false)
  useEffect(() => {
    fetchAuth('/api/loan-records?active_only=1').then(r => r.ok ? r.json() : []).then(d => {
      setLoans((Array.isArray(d) ? d : []).filter(l => l.project_id === projectId)); setLoaded(true)
    }).catch(() => setLoaded(true))
  }, [projectId])
  if (!loaded || !loans.length) return null
  return (
    <div style={{ padding: SPACE.md, background: COLORS.bgSoft, borderRadius: RADIUS.md, border: `1px solid ${COLORS.line}` }}>
      <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginBottom: 8, fontWeight: TYPO.weights.semibold, textTransform: 'uppercase' }}>Požičovňa — stroje na tejto zákazke ({loans.length})</div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
        {loans.map(l => (
          <div key={l.id} style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: TYPO.sizes.sm }}>
            <span style={{ flex: 1, fontWeight: 600 }}>{l.item_name}{l.item_code ? ' · ' + l.item_code : ''}</span>
            <span style={{ fontSize: TYPO.sizes.xs, fontWeight: 700, color: l.term === 'rocne' ? '#7c3aed' : '#0369a1' }}>{l.term === 'rocne' ? 'ROČNÉ' : 'ZÁKAZKA'}</span>
            {l.employee_name && <span style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted }}>{l.employee_name}</span>}
          </div>
        ))}
      </div>
    </div>
  )
}


// ══════════════════════════════════════════════════════════════
// VÝDAVKY TAB — sek. 22 / 29 (per zákazka náklady)
// Skupiny: Mzdy + Došlé FA + VSZAK
// POZOR sek. 9.A HIGH 1: dvojzápočet expenses ↔ payroll ↔ Pokladňa
//   Riešenie: čítame z dedikovaných tabuliek (payroll, incoming_invoices, vszak_records),
//   NIE z generického 'expenses' — vyhneme sa dvojzápočtu na frontend úrovni.
// ══════════════════════════════════════════════════════════════
function VydavkyTab({ project }) {
  const toast = useToast()
  const pinGateVbd = usePinGate()
  const [data, setData] = useState({ mzdy: [], fa: [], vszak: [], vsost: [], szcoFa: [], pending: [], bezDokladu: [], fin: null })
  const [vbdOpen, setVbdOpen] = useState(false)   // 13. 9. 2026 (bod 6): ručný výdavok bez dokladu
  const { user: meUser } = useAuth()
  const [loading, setLoading] = useState(true)
  const [confirming, setConfirming] = useState(false)

  const load = React.useCallback(() => {
    setLoading(true)
    Promise.all([
      fetchAuth(`/api/payroll`).then(r => r.ok ? r.json() : []).catch(() => []),
      fetchAuth(`/api/incoming-invoices`).then(r => r.ok ? r.json() : []).catch(() => []),
      fetchAuth(`/api/expenses?includePending=1`).then(r => r.ok ? r.json() : []).catch(() => []),
      fetchAuth(`/api/payroll/szco-fa`).then(r => r.ok ? r.json() : []).catch(() => []),
      fetchAuth(`/api/vydavky-bez-dokladu?project_id=${encodeURIComponent(project.id)}`).then(r => r.ok ? r.json() : { rows: [] }).catch(() => ({ rows: [] })),
      // p21 (16. 9. 2026, bod 6): súčty záložky z jedného vzorca zákazky — rovnaké čísla ako Info karta a zisk na Domove
      fetchAuth(`/api/projects/${encodeURIComponent(project.id)}/finance`).then(r => r.ok ? r.json() : null).catch(() => null)
    ]).then(([allMzdy, allFA, allExpenses, allSzco, bd, fin]) => {
      // Filter per project
      const mzdy = (Array.isArray(allMzdy) ? allMzdy : []).filter(m =>
        m.projectId === project.id
      )
      const fa = (Array.isArray(allFA) ? allFA : []).filter(f =>
        f.project_id === project.id
      )
      const pid = project.id
      const projExpAll = (Array.isArray(allExpenses) ? allExpenses : []).filter(e => e.projectId === pid)
      const pending = projExpAll.filter(e => e.import_status === 'pending')   // IMPORT INBOX 12.10 — čaká na potvrdenie
      const projExp = projExpAll.filter(e => e.import_status !== 'pending')
      const vszak = projExp.filter(e => e.doc_type === 'VSZAK')
      const vsost = projExp.filter(e => e.doc_type === 'VSOST')
      // SZČO FA = odmeny pracovníkov fakturované cez SZČO — sú už v `fa` (Došlé FA), tu len na ROZPOZNANIE (NEpripočítavame, ústava 9.A/99.2)
      const szcoFa = (Array.isArray(allSzco) ? allSzco : []).filter(s => s.projectId === pid)
      setData({ mzdy, fa, vszak, vsost, szcoFa, pending, bezDokladu: (bd && bd.rows) || [], fin: fin && typeof fin.naklady_spolu === 'number' ? fin : null })
    }).catch(e => {
      toast.error(`Načítanie výdavkov zlyhalo: ${e.message}`)
    }).finally(() => setLoading(false))
  }, [project.id, toast])
  useEffect(() => { load() }, [load])

  // Potvrdenie importovaných výdavkov (VSZAK/VSOST) PRIAMO v zákazke (Mirko 2026-06-29, B). Reuse /api/imports/inbox/confirm.
  const confirmPending = React.useCallback(async (ids) => {
    const list = (data.pending || [])
    const items = (ids && ids.length ? ids : list.map(e => e.id)).map(id => ({ id, source: 'expenses' }))
    if (!items.length || confirming) return
    setConfirming(true)
    try {
      const r = await fetchAuth('/api/imports/inbox/confirm', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items }) })
      const j = await r.json().catch(() => ({}))
      if (!r.ok) throw new Error(j.error || '')
      toast.success('Potvrdené: ' + (j.confirmed != null ? j.confirmed : items.length))
      load()
    } catch (e) { toast.error('Nepodarilo sa potvrdiť: ' + (e.message || '')) } finally { setConfirming(false) }
  }, [data.pending, confirming, toast, load])

  // SZČO FA = MZDOVÝ výdavok (cez SZČO faktúru) — patrí do Mzdy, NIE do Došlých FA (ústava 99.2, Mirko 2026-06-11).
  // Z Došlých FA ich vylúčime a pripočítame k Mzdám → klasifikované správne, počítané RAZ (žiadny dvojzápočet).
  const szcoInvIds = new Set((data.szcoFa || []).map(s => s.invoice_id))
  const faReal     = data.fa.filter(f => !szcoInvIds.has(f.id))
  const sumSzcoFa  = (data.szcoFa || []).reduce((s, f) => s + (f.amount || 0), 0)
  const sumMzdyReal = data.mzdy.reduce((s, m) => s + (m.amount || 0), 0)
  const sumMzdy    = sumMzdyReal + sumSzcoFa
  const sumFA      = faReal.reduce((s, f) => s + (f.amount_total || f.amount || 0), 0)
  const sumVszak   = data.vszak.reduce((s, v) => s + (v.amount || 0), 0)
  const sumVsost   = data.vsost.reduce((s, v) => s + (v.amount || 0), 0)
  const total      = sumMzdy + sumFA + sumVszak + sumVsost
  const mzdyCount  = data.mzdy.length + (data.szcoFa || []).length
  const faCount    = faReal.length

  // Mily upozornovac — bez technickeho zargonu (ustava sek. 57)
  const helpNote = (
    <div style={{
      padding: SPACE.sm,
      background: COLORS.bgSoft,
      border: `1px solid ${COLORS.line}`,
      borderRadius: RADIUS.sm,
      fontSize: TYPO.sizes.xs,
      color: COLORS.muted,
      marginBottom: SPACE.md
    }}>
      Súčty hore sú z <b>jedného vzorca zákazky</b> — rovnaké čísla ako Info karta aj zisk firmy na úvodnej obrazovke Matrix. Rátajú sa len <b>potvrdené doklady bez DPH</b>;
      pokladňa nie je náklad (výplata z pokladne je nárok v mzdách, bloček je zaradený na zákazku alebo réžiu). Pod súčtami sú zoznamy dokladov.
    </div>
  )

  // Pending import (VSZAK/VSOST z MKsoftu) — skontroluj a potvrď, až potom sa zaráta (ústava 12.10)
  const pendingBlock = (data.pending || []).length > 0 ? (
    <div style={{ border: '1px solid #f0a8a8', background: '#fff7ed', borderRadius: RADIUS.md, padding: SPACE.md }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: SPACE.sm, flexWrap: 'wrap' }}>
        <span style={{ fontWeight: TYPO.weights.bold, color: '#9a3412' }}>Čaká na odsúhlasenie — {data.pending.length}</span>
        <span style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted }}>Tu čakajú VŠETKY importy z MKsoftu (VSZAK/VSOST). Skontroluj, prípadne uprav, a potvrď — až potom sa zarátajú do nákladov.</span>
        <button onClick={() => confirmPending()} disabled={confirming} style={{ marginLeft: 'auto', padding: '6px 14px', border: 'none', background: COLORS.add, color: '#fff', borderRadius: RADIUS.sm, cursor: 'pointer', fontWeight: TYPO.weights.semibold, fontFamily: 'inherit', opacity: confirming ? 0.6 : 1 }}>✓ Potvrdiť všetky ({data.pending.length})</button>
      </div>
      <div style={{ background: COLORS.bg, border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.sm, padding: SPACE.sm }}>
        <ExpenseGroup
          title={false}
          expandable
          limit={200}
          upravy
          onSumaZmenena={(id, amount) => setData(d => ({ ...d, pending: (d.pending || []).map(e => e.id === id ? { ...e, amount } : e) }))}
          rows={data.pending}
          fields={[
            ['date', 'Dátum'],
            ['doc_type', 'Typ'],
            ['doc_number', 'Doklad'],
            ['zakazka_code', 'Č. zákazky'],
            ['odberatel', 'Komu (odberateľ)'],
            ['supplier', 'Sklad'],
            ['note', 'Poznámka'],
            ['amount', 'Suma €', 'eur'],
          ]}
          rowAction={(r) => (
            <button onClick={() => confirmPending([r.id])} disabled={confirming} style={{ padding: '3px 10px', border: `1px solid ${COLORS.add}`, background: '#fff', color: COLORS.add, borderRadius: RADIUS.sm, cursor: 'pointer', fontSize: TYPO.sizes.xs, fontFamily: 'inherit' }}>Potvrď</button>
          )}
        />
        <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginTop: SPACE.xs }}>Klik na riadok rozbalí položky dokladu. Pred potvrdením môžeš <b>opraviť jednotkovú cenu</b> podľa poslednej faktúry (MKsoft priemeruje nákupné ceny od začiatku roka) a <b>doplniť vlastný riadok</b> — doprava, amortizačný poplatok a podobne. Upravený doklad už ďalší import z MKsoftu neprepíše.</div>
      </div>
    </div>
  ) : null

  if (loading) {
    return <div style={{ color: COLORS.muted, padding: SPACE.md }}>Načítavam výdavky pre {project.id}…</div>
  }

  if (total === 0 && !data.mzdy.length && !data.fa.length && !data.vszak.length && !data.vsost.length && !(data.pending || []).length) {
    return (
      <div>
        {helpNote}
        <div style={{ padding: SPACE.xl, color: COLORS.muted, textAlign: 'center', background: COLORS.bgSoft, borderRadius: RADIUS.md }}>
          <div style={{ fontSize: 36, marginBottom: SPACE.sm }}></div>
          <div>Žiadne výdavky pre túto zákazku.</div>
          <div style={{ fontSize: TYPO.sizes.xs, marginTop: SPACE.xs }}>
            Mzdy, došlé FA ani VSZAK záznamy neboli nájdené pre {project.id}{project.zakazka_code ? ` / ${project.zakazka_code}` : ''}.
          </div>
        </div>
      </div>
    )
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: SPACE.md }}>
      {pendingBlock}

      {/* SÚHRN — sekcie_v3: karta Náklady zákazky, vysvetlenie pod otáznikom (Mirko 19. 10.: statické nesmie brať pracovnú plochu) */}
      <Sekcia nazov="Náklady zákazky" popis="bez DPH, len potvrdené doklady" style={{ marginBottom: 0 }}
        napoveda="Súčty sú z jedného vzorca zákazky — rovnaké čísla ako Info karta aj zisk firmy na úvodnej obrazovke Matrix. Rátajú sa len potvrdené doklady bez DPH; pokladňa nie je náklad (výplata z pokladne je nárok v mzdách, bloček je zaradený na zákazku alebo réžiu). Pod súčtami sú zoznamy dokladov.">
      {data.fin ? (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: SPACE.sm }}>
          <SumCard label="Mzdy (nárok)"            count={mzdyCount}  sum={data.fin.mzdy} color={COLORS.nav} />
          <SumCard label="Došlé faktúry bez DPH"   count={faCount}    sum={(data.fin.vydaje_detail || {}).dosleFa} color={COLORS.total} />
          <SumCard label="Materiál (VSZAK)"        count={data.vszak.length} sum={(data.fin.vydaje_detail || {}).vszak} color={COLORS.add} />
          <SumCard label="Pomôcky (VSOST)"         count={data.vsost.length} sum={(data.fin.vydaje_detail || {}).vsost} color="#7c3aed" />
          <SumCard label="Ručné výdavky a bločky"  count={(data.bezDokladu || []).length} sum={(data.fin.vydaje_detail || {}).ine} color={COLORS.muted} />
          <SumCard label="Náklady spolu"           count={mzdyCount + faCount + data.vszak.length + data.vsost.length} sum={data.fin.naklady_spolu} color={COLORS.text} highlight />
        </div>
      ) : (
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: SPACE.sm }}>
        <SumCard label="Mzdy"        count={mzdyCount}  sum={sumMzdy}  color={COLORS.nav} />
        <SumCard label="Došlé faktúry" count={faCount}  sum={sumFA}    color={COLORS.total} />
        <SumCard label="Materiál (VSZAK)" count={data.vszak.length} sum={sumVszak} color={COLORS.add} />
        <SumCard label="Pomôcky (VSOST)"  count={data.vsost.length} sum={sumVsost} color="#7c3aed" />
        <SumCard label="Σ Spolu"        count={mzdyCount + faCount + data.vszak.length + data.vsost.length} sum={total} color={COLORS.text} highlight />
      </div>
      )}
      </Sekcia>

      {/* VYSPRAVKY_V1: percento z výmery na výplatu partiám a kredit na výspravky (len office a vedenie) */}
      <KreditVyspravky projectId={project.id} />

      {/* SZČO FA = mzdový výdavok cez SZČO faktúru — počítané v MZDY, NIE v Došlých FA (ústava 99.2, žiadny dvojzápočet) */}
      {sumSzcoFa > 0 && (
        <div style={{ padding: SPACE.sm, background: 'rgba(124,58,237,0.06)', border: '1px solid #c4b5fd', borderRadius: RADIUS.sm, fontSize: TYPO.sizes.xs, color: '#5b21b6', lineHeight: 1.55 }}>
          {data.fin && data.fin.mzdy_detail ? (<>
            <b>SZČO faktúry pracovníkov: {SK.eur(sumSzcoFa)}</b> ({data.szcoFa.length} FA — {[...new Set(data.szcoFa.map(s => s.employee_name).filter(Boolean))].join(', ')}).
            {' '}Z toho {SK.eur(data.fin.mzdy_detail.szco_kanal || 0)} je len spôsob výplaty nároku zo zošita (nepripočítava sa), {SK.eur(data.fin.mzdy_detail.szco || 0)} je náklad mimo zošita a je v <b>Mzdy</b>. Do nákladov sa nič neráta dvakrát (rozhodnutie B, 130.2).
          </>) : (<>
          <b>Z Miezd je {SK.eur(sumSzcoFa)} mzdový výdavok cez SZČO faktúry</b> ({data.szcoFa.length} FA — {[...new Set(data.szcoFa.map(s => s.employee_name).filter(Boolean))].join(', ')}). Sú to odmeny pracovníkov fakturované cez SZČO, preto sa počítajú v <b>Mzdy</b> (nie v Došlých FA) a do Σ Spolu len raz (ústava 99.2).
          </>)}
        </div>
      )}

      {/* Detail tabuľky */}
      {mzdyCount > 0 && <ExpenseGroup title="Mzdy" rows={[
        ...data.mzdy.map(m => ({ ...m, period: `${m.year || ''}-${String(m.month || '').padStart(2,'0')}` })),
        ...(data.szcoFa || []).map(s => ({ period: `${s.year || ''}-${String(s.month || '').padStart(2,'0')}`, employeeId: `${s.employee_name || '?'} — cez SZČO FA`, notes: `mzda cez SZČO faktúru · ${s.supplier_name || ''}`, amount: s.amount })),
      ]} fields={[
        ['period', 'Obdobie'], ['employeeId', 'Zamestnanec'], ['notes', 'Poznámka'], ['amount', 'Suma €', 'eur']
      ]} />}

      {faReal.length > 0 && <ExpenseGroup title="Došlé faktúry a bločky" rows={faReal} fields={[
        ['date_issued', 'Dátum'], ['invoice_number', 'Číslo'], ['supplier_name', 'Dodávateľ'], ['cost_category', 'Kategória'], ['amount_total', 'Suma €', 'eur']
      ]} />}

      {data.vszak.length > 0 && <ExpenseGroup expandable manage upravy source="expenses" docType="VSZAK" onChanged={load} title="Vydaný materiál na zákazku (VSZAK)" rows={data.vszak} fields={[
        ['date', 'Dátum'], ['doc_number', 'Doklad'], ['odberatel', 'Komu (odberateľ)'], ['supplier', 'Sklad'], ['note', 'Poznámka'], ['amount', 'Suma €', 'eur']
      ]} />}

      {data.vsost.length > 0 && <ExpenseGroup expandable manage upravy source="expenses" docType="VSOST" onChanged={load} title="Pomôcky a réžia zo skladu (VSOST)" rows={data.vsost} fields={[
        ['date', 'Dátum'], ['doc_number', 'Doklad'], ['odberatel', 'Komu (odberateľ)'], ['supplier', 'Sklad'], ['note', 'Poznámka'], ['amount', 'Suma €', 'eur']
      ]} />}

      {/* 13. 9. 2026 (bod 6): ručné výdavky bez dokladu — svietia, kým ich majiteľ neschváli PIN-om */}
      <div style={{ background: COLORS.bg, border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.lg, padding: '10px 14px 12px' }}>   {/* sekcie_v3 */}
        <div style={{ display: 'flex', alignItems: 'center', gap: SPACE.sm, flexWrap: 'wrap' }}>
          <span style={{ fontSize: TYPO.sizes.base, fontWeight: TYPO.weights.bold, color: COLORS.muted, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Ručné výdavky bez dokladu</span>
          <span style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted }}>{data.bezDokladu.length ? `${data.bezDokladu.length} ks · ${SK.eur(data.bezDokladu.reduce((s, r) => s + (Number(r.amount) || 0), 0))}` : 'žiadne'}</span>
          <div style={{ flex: 1 }} />
          <BtnGhost onClick={() => setVbdOpen(true)} title="Výdavok bez bločku a faktúry na túto zákazku: zapíš s dôvodom, ráta sa hneď, svieti do schválenia PIN-om (majiteľ, dodatočne, bez limitu)">+ ručný výdavok bez dokladu</BtnGhost>
        </div>
        {data.bezDokladu.length > 0 && (
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: TYPO.sizes.sm, marginTop: SPACE.sm }}>
            <thead><tr style={{ color: COLORS.muted, fontSize: TYPO.sizes.xs, textAlign: 'left' }}><th>Dátum</th><th>Za čo</th><th>Dôvod</th><th>Kategória</th><th>Platba</th><th>Zapísal</th><th style={{ textAlign: 'right' }}>Suma</th><th>Stav</th></tr></thead>
            <tbody>{data.bezDokladu.map(r => (
              <tr key={r.id} style={{ borderTop: `1px solid ${COLORS.line}`, background: r.schvalene ? 'transparent' : 'rgba(245,158,11,0.12)' }}>
                <td style={{ padding: '4px 6px' }}>{r.date}</td><td style={{ padding: '4px 6px' }}>{r.note}{r.supplier ? ' (' + r.supplier + ')' : ''}</td><td style={{ padding: '4px 6px', color: COLORS.muted }}>{r.dovod}</td><td style={{ padding: '4px 6px' }}>{r.category}</td>
                <td style={{ padding: '4px 6px' }}>{r.platba === 'interne' ? 'interný' : 'pokladňa ' + (r.pokladna_id || '')}</td><td style={{ padding: '4px 6px' }}>{r.zapisal}</td>
                <td style={{ padding: '4px 6px', textAlign: 'right', fontFamily: TYPO.mono, fontWeight: 700 }}>{SK.eur(r.amount)}</td>
                <td style={{ padding: '4px 6px', whiteSpace: 'nowrap' }}>{r.schvalene ? <span style={{ color: COLORS.add }}>schválené {r.schvalil ? '(' + r.schvalil + ')' : ''}</span> : <span style={{ color: '#b45309', fontWeight: 700 }}>čaká PIN majiteľa</span>}
                  {!r.schvalene && meUser && ['admin', 'owner'].includes(meUser.role) && <BtnAdd style={{ padding: '2px 8px', fontSize: TYPO.sizes.xs, marginLeft: 6 }} onClick={async () => { const g = await pinGateVbd('vydaj_bez_dokladu', { suma: r.amount, popis: r.note, info: 'Výdavok bez dokladu — ' + (r.dovod || '') }); if (!g || !g.ok) return; const rr = await fetchAuth('/api/vydavky-bez-dokladu/' + r.id + '/schvalit', { method: 'POST', headers: { 'X-Pin-Audit-Id': String(g.audit_id || '') } }); if (!rr.ok) { const d = await rr.json().catch(() => ({})); toast.error(d.error || 'Nedá sa'); return } toast.success('Schválené'); load() }}>Schváliť (PIN)</BtnAdd>}
                </td>
              </tr>))}</tbody>
          </table>
        )}
      </div>
      {vbdOpen && <VydavokBezDokladuModal fixedProject={project} onClose={() => setVbdOpen(false)} onSaved={() => { setVbdOpen(false); load() }} />}
    </div>
  )
}

function SumCard({ label, count, sum, color, highlight }) {
  return (
    <div style={{
      background: highlight ? COLORS.bgSoft : COLORS.bg,
      border: `1px solid ${COLORS.line}`,
      borderLeft: `4px solid ${color}`,
      borderRadius: RADIUS.md,
      padding: SPACE.sm
    }}>
      <div style={{ fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.semibold, color, marginBottom: 2 }}>{label}</div>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 6 }}>
        <span style={{ fontSize: TYPO.sizes.md, fontWeight: TYPO.weights.bold, color: COLORS.text }}>{count}</span>
        <span style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, fontFamily: TYPO.mono }}>{SK.eur(sum)}</span>
      </div>
    </div>
  )
}

// ExpenseGroup — tabuľka výdavkov. Ak expandable=true, klik na riadok
// rozbalí položky dokladu (expense_items cez /api/expense-items/:id).
function ExpenseGroup({ title, rows, fields, expandable = false, manage = false, source, docType, onChanged, rowAction = null, limit = 20, upravy = false, onSumaZmenena = null }) {
  const [expanded, setExpanded] = useState(null)      // id rozbaleného dokladu
  const [itemsCache, setItemsCache] = useState({})    // { [id]: {loading,items,error} }

  async function toggleRow(id) {
    if (!expandable || !id) return
    if (expanded === id) { setExpanded(null); return }
    setExpanded(id)
    if (!itemsCache[id]) {
      setItemsCache(p => ({ ...p, [id]: { loading: true } }))
      try {
        const r = await fetchAuth(`/api/expense-items/${encodeURIComponent(id)}`)
        const items = r.ok ? await r.json() : []
        setItemsCache(p => ({ ...p, [id]: { loading: false, items: Array.isArray(items) ? items : [] } }))
      } catch (e) {
        setItemsCache(p => ({ ...p, [id]: { loading: false, items: [], error: e.message } }))
      }
    }
  }

  const colCount = fields.length + (expandable ? 1 : 0) + (manage ? 1 : 0) + (rowAction ? 1 : 0)

  return (
    <div style={title !== false ? { background: COLORS.bg, border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.lg, padding: '2px 14px 12px' } : undefined}>   {/* sekcie_v3: skupina dokladov je karta */}
      {title !== false && <div style={{ fontSize: TYPO.sizes.base, fontWeight: TYPO.weights.bold, color: COLORS.muted, textTransform: 'uppercase', letterSpacing: '0.05em', padding: '12px 0 8px' }}>
        {title} <span style={{ fontWeight: TYPO.weights.normal, textTransform: 'none', letterSpacing: 0, fontSize: TYPO.sizes.sm }}>· {rows.length} záznam(ov)</span>
        {expandable && <span style={{ color: COLORS.muted, fontWeight: TYPO.weights.normal, fontSize: TYPO.sizes.xs, textTransform: 'none', letterSpacing: 0 }}> · klik na riadok = položky dokladu</span>}
      </div>}
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: TYPO.sizes.xs }}>
        <thead>
          <tr style={{ background: COLORS.bgSoft, borderBottom: `2px solid ${COLORS.line}` }}>
            {expandable && <th style={{ width: 24, padding: 6 }}></th>}
            {fields.map(([k, lbl]) => (
              <th key={k} style={{ padding: 6, textAlign: k.includes('amount') || k.includes('suma') ? 'right' : 'left', fontWeight: TYPO.weights.semibold, color: COLORS.muted }}>{lbl}</th>
            ))}
            {manage && <th style={{ width: 32, padding: 6 }}></th>}
            {rowAction && <th style={{ width: 80, padding: 6 }}></th>}
          </tr>
        </thead>
        <tbody>
          {rows.slice(0, limit).map((r, i) => {
            const rid = r.id
            const isOpen = expandable && expanded === rid
            const cache = itemsCache[rid]
            return (
              <React.Fragment key={rid || i}>
                <tr
                  onClick={() => toggleRow(rid)}
                  style={{
                    borderBottom: `1px solid ${COLORS.lineSoft}`,
                    cursor: expandable ? 'pointer' : 'default',
                    background: isOpen ? COLORS.navBg : 'transparent'
                  }}
                >
                  {expandable && (
                    <td style={{ padding: 6, textAlign: 'center', color: COLORS.nav, fontWeight: TYPO.weights.bold }}>
                      {isOpen ? '▾' : '▸'}
                    </td>
                  )}
                  {fields.map(([k, lbl, type]) => (
                    <td key={k} style={{ padding: 6, textAlign: type === 'eur' ? 'right' : 'left', fontFamily: type === 'eur' ? TYPO.mono : TYPO.family, fontWeight: type === 'eur' ? TYPO.weights.semibold : TYPO.weights.normal }}>
                      {type === 'eur' ? SK.eur(r[k] || 0) : (r[k] || '—')}
                    </td>
                  ))}
                  {manage && (
                    <td style={{ padding: 6, textAlign: 'center' }} onClick={e => e.stopPropagation()}>
                      <DocRowActions row={r} source={source} docType={docType} onChanged={onChanged} />
                    </td>
                  )}
                  {rowAction && (
                    <td style={{ padding: 6, textAlign: 'right' }} onClick={e => e.stopPropagation()}>
                      {rowAction(r)}
                    </td>
                  )}
                </tr>
                {isOpen && (
                  <tr>
                    <td colSpan={colCount} style={{ padding: 0, background: COLORS.bgSoft }}>
                      <ItemsSubtable cache={cache} upravy={upravy} expenseId={rid}
                        onZmena={(items, amount) => { setItemsCache(p => ({ ...p, [rid]: { loading: false, items } })); onSumaZmenena && onSumaZmenena(rid, amount) }} />
                    </td>
                  </tr>
                )}
              </React.Fragment>
            )
          })}
          {rows.length > limit && (
            <tr><td colSpan={colCount} style={{ padding: 8, textAlign: 'center', color: COLORS.muted, fontSize: TYPO.sizes.xs, fontStyle: 'italic' }}>
              … a ďalších {rows.length - limit} záznamov (zobrazujem prvých {limit})
            </td></tr>
          )}
        </tbody>
      </table>
    </div>
  )
}

// ── RowMenu (F2, Mirko 2026-06-05) — ⋮ akcie importovaného dokladu: Upraviť/priradiť · Tlačiť PDF · Zmazať ──
// DocRowActions (F2) — používa ŠTANDARDNÝ RowMenu (ústava sek. 66) + drží modaly akcií
function DocRowActions({ row, source, docType, onChanged }) {
  const toast = useToast()
  const [edit, setEdit] = useState(false)
  const [confirmDel, setConfirmDel] = useState(false)
  const [busy, setBusy] = useState(false)

  const doDelete = async () => {
    setBusy(true)
    try {
      const r = await fetchAuth(`/api/${source}/${row.id}`, { method: 'DELETE' })
      if (!r.ok) throw new Error('HTTP ' + r.status)
      toast.success('Doklad zmazaný — vrátiteľné cez Nastavenia → LOG zmien')
      setConfirmDel(false)
      onChanged && onChanged()
    } catch (e) { toast.error('Zmazanie zlyhalo: ' + e.message) }
    finally { setBusy(false) }
  }

  const doPrint = async () => {
    let items = []
    try { const r = await fetchAuth(`/api/expense-items/${encodeURIComponent(row.id)}`); items = r.ok ? await r.json() : [] } catch (_) {}
    printDocSummary(row, docType, Array.isArray(items) ? items : [])
  }

  const actions = [
    { icon: '', label: 'Upraviť / priradiť', onClick: () => setEdit(true) },
    { icon: '', label: 'Tlačiť PDF súhrnu', onClick: doPrint },
    { icon: '', label: 'Zmazať', danger: true, onClick: () => setConfirmDel(true) },
  ]

  return (
    <>
      <RowMenu actions={actions} compact />
      {edit && <EditAssignModal row={row} source={source} onClose={() => setEdit(false)} onSaved={() => { setEdit(false); onChanged && onChanged() }} />}
      <Modal open={confirmDel} onClose={() => setConfirmDel(false)} title="Zmazať doklad?"
        footer={<>
          <BtnGhost onClick={() => setConfirmDel(false)}>Zrušiť</BtnGhost>
          <BtnDanger onClick={doDelete} disabled={busy}>{busy ? 'Mažem…' : 'Zmazať'}</BtnDanger>
        </>}>
        <div>
          Naozaj zmazať doklad <b>{row.doc_number || row.id}</b> ({SK.eur(row.amount || 0)})?
          <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginTop: SPACE.xs }}>Zmazanie sa zapíše do LOG zmien a dá sa vrátiť.</div>
        </div>
      </Modal>
    </>
  )
}

// EditAssignModal — zmena priradenia zákazky + poznámky importovaného dokladu
function EditAssignModal({ row, source, onClose, onSaved }) {
  const toast = useToast()
  const [projects, setProjects] = useState([])
  const [proj, setProj] = useState(row.projectId || row.project_id || '')
  const [note, setNote] = useState(row.note || '')
  const [busy, setBusy] = useState(false)
  useEffect(() => { fetchAuth('/api/projects').then(r => r.ok ? r.json() : []).then(d => setProjects(Array.isArray(d) ? d : [])).catch(() => {}) }, [])

  const save = async () => {
    setBusy(true)
    try {
      // jeden PUT — mení priradenie zákazky aj poznámku; audit cez makeRouter (old/new)
      const r = await fetchAuth(`/api/${source}/${row.id}`, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ ...row, projectId: proj || null, note }) })
      if (!r.ok) {
        if (r.status === 409) throw new Error('Doklad medzitým zmenil iný používateľ — obnov stránku.')
        throw new Error('HTTP ' + r.status)
      }
      toast.success('Uložené')
      onSaved && onSaved()
    } catch (e) { toast.error('Uloženie zlyhalo: ' + e.message) }
    finally { setBusy(false) }
  }

  return (
    <Modal open onClose={onClose} title={`Upraviť doklad ${row.doc_number || row.id}`}
      footer={<>
        <BtnGhost onClick={onClose}>Zrušiť</BtnGhost>
        <BtnAdd onClick={save} disabled={busy}>{busy ? 'Ukladám…' : 'Uložiť'}</BtnAdd>
      </>}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: SPACE.md }}>
        <div>
          <div style={{ fontSize: TYPO.sizes.sm, fontWeight: TYPO.weights.semibold, marginBottom: 4 }}>Zákazka</div>
          <select value={proj} onChange={e => setProj(e.target.value)} style={{ width: '100%', padding: '8px 10px', border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.sm, fontFamily: 'inherit', fontSize: TYPO.sizes.sm }}>
            <option value="">— nepriradené —</option>
            {projects.map(p => <option key={p.id} value={p.id}>{(p.zakazka_code || p.id) + ' · ' + (p.name || '')}</option>)}
          </select>
        </div>
        <Textarea label="Poznámka" value={note} onChange={v => setNote(v)} rows={2} />
      </div>
    </Modal>
  )
}

// printDocSummary — klientská tlač A4 súhrnu dokladu (hlavička + položky)
function printDocSummary(row, docType, items) {
  const esc = s => String(s == null ? '' : s).replace(/[&<>]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c]))
  const eur = n => (Number(n) || 0).toLocaleString('sk-SK', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'
  const rowsHtml = items.map(it => `<tr><td>${esc(it.plu || '')}</td><td>${esc(it.name || '')}</td><td style="text-align:right">${esc(it.quantity ?? '')}</td><td>${esc(it.unit || '')}</td><td style="text-align:right">${eur(it.unit_price)}</td><td style="text-align:right">${eur(it.total_price)}</td></tr>`).join('')
  const html = `<!doctype html><html><head><meta charset="utf-8"><title>${esc(docType)} ${esc(row.doc_number || row.id)}</title>
  <style>body{font-family:Arial,Helvetica,sans-serif;color:#222;margin:32px;font-size:13px}h1{font-size:18px;margin:0 0 4px}table{width:100%;border-collapse:collapse;margin-top:14px}th,td{border:1px solid #ccc;padding:5px 7px}th{background:#f3f3f3;text-align:left;font-size:11px}.meta{margin-top:8px;color:#444}.meta div{margin:2px 0}.tot{text-align:right;font-weight:bold;font-size:14px;margin-top:10px}@media print{button{display:none}}</style>
  </head><body>
  <h1>Súhrn dokladu — ${esc(docType || '')}</h1>
  <div class="meta">
    <div><b>Doklad:</b> ${esc(row.doc_number || row.id)}</div>
    <div><b>Dátum:</b> ${esc(row.date || '')}</div>
    <div><b>Sklad / dodávateľ:</b> ${esc(row.supplier || '')}</div>
    ${row.odberatel ? `<div><b>Komu (odberateľ):</b> ${esc(row.odberatel)}${row.odberatel_kod ? ' · ' + esc(row.odberatel_kod) : ''}</div>` : ''}
    ${row.note ? `<div><b>Poznámka:</b> ${esc(row.note)}</div>` : ''}
  </div>
  ${items.length ? `<table><thead><tr><th>PLU</th><th>Názov položky</th><th style="text-align:right">Množstvo</th><th>MJ</th><th style="text-align:right">Jedn. cena</th><th style="text-align:right">Spolu</th></tr></thead><tbody>${rowsHtml}</tbody></table>` : '<p style="margin-top:14px;color:#888">Doklad nemá rozpísané položky.</p>'}
  <div class="tot">Suma dokladu: ${eur(row.amount)}</div>
  <button onclick="window.print()" style="margin-top:20px;padding:8px 16px">Tlačiť</button>
  </body></html>`
  const w = window.open('', '_blank')
  if (!w) return
  w.document.write(html); w.document.close()
  setTimeout(() => { try { w.focus(); w.print() } catch (_) {} }, 350)
}

// ItemsSubtable — položky dokladu (rozbalené pod riadkom VSZAK/VSOST)
function ItemsSubtable({ cache, upravy = false, expenseId = null, onZmena = null }) {
  const toast = useToast()
  const opytajSa = useConfirm()
  const [novy, setNovy] = useState(null)   // rozpísaný vlastný riadok { name, quantity, unit, unit_price }
  const [posiela, setPosiela] = useState(false)
  // Čakáreň (Mirko 29. 9. 2026): oprava jedn. ceny podľa poslednej faktúry (MKsoft priemeruje) + vlastný riadok (doprava, amortizácia…)
  // Čakáreň (Mirko 29. 9. 2026): oprava jedn. ceny podľa poslednej faktúry (MKsoft priemeruje) + vlastný riadok (doprava, amortizácia…)
  // cena_v2 (Mirko 30. 9. 2026: „ako tu upravím cenu???"): doklad sa dá opraviť aj PO potvrdení — server vtedy vráti 409
  // POTVRDENY_DOKLAD, Matrix si vypýta dôvod vo vlastnom okne a pošle to isté volanie znova. Platí pre cenu, vlastný
  // riadok aj mazanie, nie len pre cenu — potvrdený doklad je náklad zákazky a každá jeho zmena má mať dôvod v histórii.
  async function volaj(metoda, cesta, telo, dovod = '', sprava = '') {
    if (posiela) return
    setPosiela(true)
    let r, j = {}
    try {
      const telo2 = (telo || dovod) ? { ...(telo || {}), ...(dovod ? { dovod } : {}) } : null
      r = await fetchAuth('/api/vszak-cakaren' + cesta, { method: metoda, headers: { 'Content-Type': 'application/json' }, body: telo2 ? JSON.stringify(telo2) : undefined })
      j = await r.json().catch(() => ({}))
    } catch (e) { toast.error(e.message); return } finally { setPosiela(false) }
    if (r.status === 409 && j.code === 'POTVRDENY_DOKLAD' && !dovod) {
      const v = await opytajSa({
        title: 'Doklad je už potvrdený',
        message: (sprava ? sprava + '\n' : '') + 'Zmení sa tým náklad zákazky a suma dokladu. Oprava zostane v histórii dokladu s tvojím menom.',
        confirmLabel: 'Opraviť aj tak',
        dovod: { label: 'Dôvod opravy', placeholder: 'napr. cena podľa faktúry Baumit 12345', hint: 'Nech je o pol roka jasné, prečo sa potvrdený doklad menil.', povinne: true },
      })
      if (!v || !v.dovod) return
      return volaj(metoda, cesta, telo, v.dovod, sprava)
    }
    if (!r.ok) { toast.error(j.error || 'Nepodarilo sa.'); return }
    onZmena && onZmena(j.items, j.amount)
    return true
  }
  const zmenCenu = (it, v) => {
    const c = parseFloat(String(v).replace(/[\s\u00a0\u202f€]/g, '').replace(',', '.'))   // „1 295,60", „2,00 €"
    if (isNaN(c) || c < 0 || Math.abs(c - (it.unit_price || 0)) < 0.0001) return
    const sprava = 'Cena „' + it.name + '" sa zmení z ' + SK.eur(it.unit_price || 0) + ' na ' + SK.eur(c) + ' za ' + (it.unit || 'MJ') + '.'
    volaj('PUT', '/polozka/' + it.id, { unit_price: c }, '', sprava).then(ok => { if (ok) toast.success('Cena „' + it.name + '" upravená — suma dokladu prepočítaná.') })
  }
  const pridajRiadok = () => {
    const n = novy || {}
    if (!(n.name || '').trim()) { toast.warn('Napíš popis riadku (napr. doprava, amortizačný poplatok).'); return }
    volaj('POST', '/' + encodeURIComponent(expenseId) + '/riadok', { name: n.name, quantity: n.quantity || 1, unit: n.unit || 'ks', unit_price: n.unit_price })
      .then(ok => { if (ok) { setNovy(null); toast.success('Riadok doplnený — suma dokladu prepočítaná.') } })
  }
  const inp = (v, on, w, ph, right) => <input value={v ?? ''} onChange={e => on(e.target.value)} placeholder={ph || ''}
    style={{ width: w, padding: '3px 6px', border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.sm, fontSize: TYPO.sizes.xs, fontFamily: right ? TYPO.mono : TYPO.family, textAlign: right ? 'right' : 'left', boxSizing: 'border-box' }} />
  const pridavaci = upravy ? (
    <div style={{ padding: `${SPACE.xs}px ${SPACE.sm}px`, borderTop: `1px dashed ${COLORS.line}` }}>
      {!novy
        ? <button onClick={() => setNovy({ quantity: 1, unit: 'ks' })} style={{ padding: '3px 10px', border: `1px dashed ${COLORS.nav}`, background: '#fff', color: COLORS.nav, borderRadius: RADIUS.sm, cursor: 'pointer', fontSize: TYPO.sizes.xs, fontFamily: 'inherit' }}>+ Doplniť riadok (doprava, amortizačný poplatok…)</button>
        : <div style={{ display: 'flex', gap: 6, alignItems: 'center', flexWrap: 'wrap' }}>
            {inp(novy.name, v => setNovy({ ...novy, name: v }), 260, 'popis — napr. doprava, amortizačný poplatok')}
            {inp(novy.quantity, v => setNovy({ ...novy, quantity: v }), 56, 'množ.', true)}
            {inp(novy.unit, v => setNovy({ ...novy, unit: v }), 46, 'MJ')}
            {inp(novy.unit_price, v => setNovy({ ...novy, unit_price: v }), 76, 'jedn. cena €', true)}
            <button onClick={pridajRiadok} disabled={posiela} style={{ padding: '3px 12px', border: 'none', background: COLORS.add, color: '#fff', borderRadius: RADIUS.sm, cursor: 'pointer', fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.semibold, fontFamily: 'inherit' }}>Pridať</button>
            <button onClick={() => setNovy(null)} style={{ padding: '3px 8px', border: `1px solid ${COLORS.line}`, background: '#fff', borderRadius: RADIUS.sm, cursor: 'pointer', fontSize: TYPO.sizes.xs, fontFamily: 'inherit' }}>Zrušiť</button>
          </div>}
    </div>
  ) : null
  if (!cache || cache.loading) {
    return <div style={{ padding: SPACE.sm, color: COLORS.muted, fontSize: TYPO.sizes.xs }}>Načítavam položky…</div>
  }
  if (cache.error) {
    return <div style={{ padding: SPACE.sm, color: COLORS.remove, fontSize: TYPO.sizes.xs }}>Chyba: {cache.error}</div>
  }
  if (!cache.items || cache.items.length === 0) {
    return <div>
      <div style={{ padding: SPACE.sm, color: COLORS.muted, fontSize: TYPO.sizes.xs, fontStyle: 'italic' }}>Tento doklad nemá rozpísané položky.</div>
      {pridavaci}
    </div>
  }
  return (<div>
    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: TYPO.sizes.xs, margin: `${SPACE.xs}px 0` }}>
      <thead>
        <tr style={{ color: COLORS.muted }}>
          <th style={{ padding: '3px 8px', textAlign: 'left' }}>PLU</th>
          <th style={{ padding: '3px 8px', textAlign: 'left' }}>Názov položky</th>
          <th style={{ padding: '3px 8px', textAlign: 'right' }}>Množstvo</th>
          <th style={{ padding: '3px 8px', textAlign: 'left' }}>MJ</th>
          <th style={{ padding: '3px 8px', textAlign: 'right' }}>Jedn. cena</th>
          <th style={{ padding: '3px 8px', textAlign: 'right' }}>Spolu</th>
        </tr>
      </thead>
      <tbody>
        {cache.items.map((it, idx) => (
          <tr key={idx} style={{ borderTop: `1px solid ${COLORS.line}` }}>
            <td style={{ padding: '3px 8px', fontFamily: TYPO.mono, color: COLORS.muted }}>{it.plu || '—'}</td>
            <td style={{ padding: '3px 8px' }}>{it.name || '—'}</td>
            <td style={{ padding: '3px 8px', textAlign: 'right', fontFamily: TYPO.mono }}>{it.quantity ?? '—'}</td>
            <td style={{ padding: '3px 8px' }}>{it.unit || '—'}</td>
            <td style={{ padding: '3px 8px', textAlign: 'right', fontFamily: TYPO.mono }}>
              {upravy
                ? <input key={it.id + ':' + it.unit_price} defaultValue={String(it.unit_price ?? '').replace('.', ',')} disabled={posiela} title="Oprav cenu podľa poslednej faktúry — MKsoft priemeruje nákupné ceny"
                    onBlur={e => zmenCenu(it, e.target.value)} onKeyDown={e => { if (e.key === 'Enter') e.target.blur() }}
                    style={{ width: 72, padding: '2px 6px', border: `1px solid ${COLORS.nav}`, borderRadius: RADIUS.sm, textAlign: 'right', fontFamily: TYPO.mono, fontSize: TYPO.sizes.xs, background: '#fff', boxSizing: 'border-box' }} />
                : SK.eur(it.unit_price || 0)}
            </td>
            <td style={{ padding: '3px 8px', textAlign: 'right', fontFamily: TYPO.mono, fontWeight: TYPO.weights.semibold }}>
              {SK.eur(it.total_price || 0)}
              {upravy && Number(it.rucne) === 1 && <button onClick={() => volaj('DELETE', '/polozka/' + it.id)} disabled={posiela} title="Zmazať ručne doplnený riadok"
                style={{ marginLeft: 6, padding: '0 6px', border: `1px solid ${COLORS.remove}`, background: '#fff', color: COLORS.remove, borderRadius: RADIUS.sm, cursor: 'pointer', fontSize: TYPO.sizes.xs, fontFamily: 'inherit' }}>✕</button>}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
      {pridavaci}
    </div>
  )
}

// ══════════════════════════════════════════════════════════════
// CHANGE ORDER TAB — sek. 32
// ══════════════════════════════════════════════════════════════
function ChangeOrderTab({ project, onProjectReload, onParentReload }) {
  const { user } = useAuth()
  const toast = useToast()
  const [orders, setOrders] = useState([])
  const [loading, setLoading] = useState(true)
  const [newModal, setNewModal] = useState(false)
  const [decideModal, setDecideModal] = useState(null)  // { co, status: 'schvalene'|'zamietnute' }

  const canApprove = ['admin', 'majitel', 'office_manager'].includes(user?.role)

  function reload() {
    setLoading(true)
    fetchAuthJSON(`/api/change-orders?project_id=${project.id}`)
      .then(rows => setOrders(Array.isArray(rows) ? rows : []))
      .catch(e => toast.error(`Načítanie Change Orders zlyhalo: ${e.message}`))
      .finally(() => setLoading(false))
  }

  useEffect(reload, [project.id])

  const pending = orders.filter(o => o.status === 'cakac')
  const decided = orders.filter(o => o.status !== 'cakac')

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: SPACE.md }}>
      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', gap: SPACE.md }}>
        <div>
          <div style={{ fontSize: TYPO.sizes.md, fontWeight: TYPO.weights.bold }}>Change Orders (zmenové príkazy)</div>
          <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted }}>
            Ústava sek. 32 — zákazka sa nedá ukončiť pokiaľ existuje neschválený CO
          </div>
        </div>
        <div style={{ flex: 1 }} />
        {project.status !== 'done' && (
          <BtnAdd onClick={() => setNewModal(true)}>+ Nový Change Order</BtnAdd>
        )}
      </div>

      {/* Pending alert */}
      {pending.length > 0 && (
        <div style={{
          padding: SPACE.md,
          background: 'rgba(245,158,11,0.12)',
          border: `2px solid ${COLORS.total}`,
          borderRadius: RADIUS.md
        }}>
          <div style={{ fontSize: TYPO.sizes.sm, fontWeight: TYPO.weights.bold, color: COLORS.total }}>
            {pending.length} CO čaká na schválenie
          </div>
          <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginTop: 2 }}>
            Zákazka sa nedá ukončiť dokým majiteľ neschváli/nezamietne všetky CO.
          </div>
        </div>
      )}

      {loading ? (
        <div style={{ color: COLORS.muted, padding: SPACE.md }}>Načítavam…</div>
      ) : orders.length === 0 ? (
        <div style={{ padding: SPACE.lg, color: COLORS.muted, textAlign: 'center', fontSize: TYPO.sizes.sm, background: COLORS.bgSoft, borderRadius: RADIUS.md }}>
          Žiadne Change Orders pre túto zákazku.
        </div>
      ) : (
        <CoTable orders={orders} canApprove={canApprove} onDecide={(co, status) => setDecideModal({ co, status })} />
      )}

      {newModal && (
        <NewChangeOrderModal
          open={newModal}
          project={project}
          onClose={() => setNewModal(false)}
          onCreated={() => {
            setNewModal(false)
            reload()
            toast.success('Change Order vytvorený, čaká na schválenie')
          }}
        />
      )}
      {decideModal && (
        <DecideChangeOrderModal
          open={!!decideModal}
          co={decideModal.co}
          targetStatus={decideModal.status}
          onClose={() => setDecideModal(null)}
          onDone={() => {
            setDecideModal(null)
            reload()
            toast.success(decideModal.status === 'schvalene' ? 'Change Order schválený' : 'Change Order zamietnutý')
          }}
        />
      )}
    </div>
  )
}

// ── CO Table ───────────────────────────────────────────────────
function CoTable({ orders, canApprove, onDecide }) {
  return (
    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: TYPO.sizes.sm }}>
      <thead>
        <tr style={{ background: COLORS.bgSoft, borderBottom: `2px solid ${COLORS.line}` }}>
          <th style={{ padding: 8, textAlign: 'left', fontWeight: TYPO.weights.semibold, color: COLORS.muted }}>Popis</th>
          <th style={{ padding: 8, textAlign: 'right', fontWeight: TYPO.weights.semibold, color: COLORS.muted, width: 110 }}>Cenový dopad</th>
          <th style={{ padding: 8, textAlign: 'left', fontWeight: TYPO.weights.semibold, color: COLORS.muted, width: 140 }}>Stav</th>
          <th style={{ padding: 8, textAlign: 'left', fontWeight: TYPO.weights.semibold, color: COLORS.muted, width: 140 }}>Akcia</th>
        </tr>
      </thead>
      <tbody>
        {orders.map(co => {
          const statusStyle =
            co.status === 'cakac'     ? { c: COLORS.total,  bg: 'rgba(245,158,11,0.12)', l: 'Čaká na schválenie' } :
            co.status === 'schvalene' ? { c: COLORS.add,    bg: COLORS.addBg,            l: '✓ Schválené' } :
            co.status === 'zamietnute'? { c: COLORS.remove, bg: COLORS.removeBg,         l: '✗ Zamietnuté' } :
                                        { c: COLORS.muted,  bg: COLORS.lineSoft,         l: 'archív' }
          return (
            <tr key={co.id} style={{ borderBottom: `1px solid ${COLORS.lineSoft}`, verticalAlign: 'top' }}>
              <td style={{ padding: 8 }}>
                <div style={{ fontWeight: TYPO.weights.semibold }}>{co.description}</div>
                {co.rozsah && <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginTop: 2 }}>Rozsah: {co.rozsah}</div>}
                {co.reason && <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginTop: 2, fontStyle: 'italic' }}>Dôvod: {co.reason}</div>}
                <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginTop: 4 }}>
                  Vytvoril {co.created_by_name || '?'} · {co.created_at?.slice(0, 16) || ''}
                </div>
                {co.decided_at && (
                  <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginTop: 2 }}>
                    {co.status === 'schvalene' ? 'Schválil' : 'Zamietol'} {co.decided_by_name || '?'} · {co.decided_at?.slice(0, 16)}
                    {co.decided_reason && ` — ${co.decided_reason}`}
                  </div>
                )}
              </td>
              <td style={{ padding: 8, textAlign: 'right', fontWeight: TYPO.weights.bold, color: co.amount_delta >= 0 ? COLORS.add : COLORS.remove, fontFamily: TYPO.mono }}>
                {co.amount_delta >= 0 ? '+' : ''}{SK.eur(co.amount_delta || 0)}
              </td>
              <td style={{ padding: 8 }}>
                <span style={{
                  padding: '2px 8px',
                  fontSize: TYPO.sizes.xs,
                  fontWeight: TYPO.weights.semibold,
                  color: statusStyle.c,
                  background: statusStyle.bg,
                  border: `1px solid ${statusStyle.c}`,
                  borderRadius: RADIUS.full,
                  whiteSpace: 'nowrap'
                }}>{statusStyle.l}</span>
              </td>
              <td style={{ padding: 8 }}>
                {co.status === 'cakac' && canApprove && (
                  <div style={{ display: 'flex', gap: 4 }}>
                    <button onClick={() => onDecide(co, 'schvalene')} style={{
                      padding: '3px 8px', fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.semibold,
                      color: '#fff', background: COLORS.add, border: 'none', borderRadius: RADIUS.sm, cursor: 'pointer'
                    }}>✓ Schváliť</button>
                    <button onClick={() => onDecide(co, 'zamietnute')} style={{
                      padding: '3px 8px', fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.semibold,
                      color: '#fff', background: COLORS.remove, border: 'none', borderRadius: RADIUS.sm, cursor: 'pointer'
                    }}>✗ Zamietnuť</button>
                  </div>
                )}
                {co.status === 'cakac' && !canApprove && (
                  <span style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, fontStyle: 'italic' }}>iba majiteľ</span>
                )}
              </td>
            </tr>
          )
        })}
      </tbody>
    </table>
  )
}

// ── New Change Order Modal ─────────────────────────────────────
function NewChangeOrderModal({ open, project, onClose, onCreated }) {
  const toast = useToast()
  const { user } = useAuth()
  // P1.3_USELOCK_2026-05-30: zámok per-projekt aby sa CO nepridal 2× paralelne
  const { lockInfo, acquired } = useLock(open && project?.id ? 'change_order_new' : null, project?.id, user)
  const isLocked = open && !acquired && !!lockInfo?.by
  const form = useDirtyState({ description: '', rozsah: '', amount_delta: '', reason: '' })
  const [coDirtyDialog, setCoDirtyDialog] = useState(false)  // fix 2026-07-16: props dirty/onDirtyConfirmClose Modal nepoznal -> guard bol MRTVY
  const updateField = (k, v) => form.setValue({ ...form.value, [k]: v })
  const [phase, setPhase] = useState('form')
  const [saving, setSaving] = useState(false)

  async function doSave() {
    if (!form.value.description.trim()) {
      toast.error('Popis je povinný')
      setPhase('form')
      return
    }
    setSaving(true)
    try {
      const payload = {
        project_id: project.id,
        description: form.value.description.trim(),
        rozsah: form.value.rozsah,
        amount_delta: SK.parse(String(form.value.amount_delta)) || 0,
        reason: form.value.reason
      }
      const r = await fetchAuth('/api/change-orders', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
      if (!r.ok) {
        const j = await r.json().catch(() => ({}))
        toast.error(j.message || j.error || `HTTP ${r.status}`)
        setPhase('form')
      } else {
        onCreated()
        form.reset()
      }
    } catch (e) {
      toast.error(`Chyba: ${e.message}`)
    } finally {
      setSaving(false)
    }
  }

  const footer = phase === 'form' ? (
    <>
      <BtnGhost onClick={onClose}>Zrušiť</BtnGhost>
      <BtnNav disabled={isLocked} onClick={() => {
        if (!form.value.description.trim()) { toast.error('Popis je povinný'); return }
        setPhase('confirm')
      }}>{isLocked ? `Zamknuté (${lockInfo.by})` : 'Pokračovať na potvrdenie →'}</BtnNav>
    </>
  ) : (
    <>
      <BtnGhost onClick={() => setPhase('form')}>← Späť</BtnGhost>
      <BtnAdd onClick={doSave} disabled={saving || isLocked}>
        {saving ? 'Ukladám…' : (isLocked ? 'Zamknuté' : '✓ Potvrdiť vytvorenie')}
      </BtnAdd>
    </>
  )

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={phase === 'form' ? `Nový Change Order pre ${project.name}` : 'Potvrdiť Change Order'}
      subtitle={phase === 'form' ? 'Vyplň údaje, potom Pokračuj na potvrdenie' : 'Po potvrdení čaká CO na schválenie majiteľa'}
      footer={footer}
      isDirty={form.isDirty}
      onDirtyClose={() => setCoDirtyDialog(true)}
    >
      {phase === 'form' ? (
        <div style={{ display: 'flex', flexDirection: 'column', gap: SPACE.md }}>
          <Textarea label="Popis zmeny *" value={form.value.description} onChange={v => updateField('description', v)} rows={2} placeholder="napr. Dodatočná chodba 20 m² omietky" />
          <Input label="Rozsah" value={form.value.rozsah} onChange={v => updateField('rozsah', v)} placeholder="napr. 20 m², 5 ks, atď." />
          <NumberInput label="Cenový dopad (€) — kladná = navýšenie, záporná = zníženie" value={form.value.amount_delta} onChange={v => updateField('amount_delta', v)} placeholder="+800,00 alebo -200,00" />
          <Textarea label="Dôvod" value={form.value.reason} onChange={v => updateField('reason', v)} rows={2} placeholder="napr. klient požiadal, technologická zmena…" />
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: SPACE.md }}>
          <div style={{ padding: SPACE.md, background: COLORS.navBg, borderRadius: RADIUS.md, border: `1px solid ${COLORS.nav}` }}>
            <div style={{ fontSize: TYPO.sizes.sm, fontWeight: TYPO.weights.semibold, color: COLORS.nav }}>
              Vznikne Change Order, ktorý čaká na schválenie majiteľa:
            </div>
          </div>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: TYPO.sizes.sm }}>
            <tbody>
              <tr style={{ borderBottom: `1px solid ${COLORS.lineSoft}` }}>
                <td style={{ padding: '6px 8px', color: COLORS.muted, width: 140 }}>Zákazka</td>
                <td style={{ padding: '6px 8px', fontWeight: TYPO.weights.semibold }}>{project.name}</td>
              </tr>
              <tr style={{ borderBottom: `1px solid ${COLORS.lineSoft}` }}>
                <td style={{ padding: '6px 8px', color: COLORS.muted }}>Popis</td>
                <td style={{ padding: '6px 8px', fontWeight: TYPO.weights.semibold }}>{form.value.description}</td>
              </tr>
              <tr style={{ borderBottom: `1px solid ${COLORS.lineSoft}` }}>
                <td style={{ padding: '6px 8px', color: COLORS.muted }}>Rozsah</td>
                <td style={{ padding: '6px 8px' }}>{form.value.rozsah || '—'}</td>
              </tr>
              <tr style={{ borderBottom: `1px solid ${COLORS.lineSoft}` }}>
                <td style={{ padding: '6px 8px', color: COLORS.muted }}>Cenový dopad</td>
                <td style={{ padding: '6px 8px', fontWeight: TYPO.weights.bold, color: (SK.parse(String(form.value.amount_delta)) || 0) >= 0 ? COLORS.add : COLORS.remove }}>
                  {(SK.parse(String(form.value.amount_delta)) || 0) >= 0 ? '+' : ''}{SK.eur(SK.parse(String(form.value.amount_delta)) || 0)}
                </td>
              </tr>
              <tr>
                <td style={{ padding: '6px 8px', color: COLORS.muted }}>Dôvod</td>
                <td style={{ padding: '6px 8px' }}>{form.value.reason || '—'}</td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
      <Modal.DirtyConfirm open={coDirtyDialog}
        onSave={() => setCoDirtyDialog(false)}
        onContinue={() => setCoDirtyDialog(false)}
        onDiscard={() => { setCoDirtyDialog(false); form.discard && form.discard(); onClose() }} />
    </Modal>
  )
}

// ── Decide CO Modal (Schvaliť / Zamietnuť) ─────────────────────
function DecideChangeOrderModal({ open, co, targetStatus, onClose, onDone }) {
  const toast = useToast()
  const [reason, setReason] = useState('')
  const [saving, setSaving] = useState(false)

  async function doDecide() {
    setSaving(true)
    try {
      const r = await fetchAuth(`/api/change-orders/${co.id}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ status: targetStatus, decided_reason: reason })
      })
      if (!r.ok) {
        const j = await r.json().catch(() => ({}))
        toast.error(j.message || j.error || `HTTP ${r.status}`)
      } else {
        onDone()
      }
    } catch (e) {
      toast.error(`Chyba: ${e.message}`)
    } finally {
      setSaving(false)
    }
  }

  const isApprove = targetStatus === 'schvalene'
  const verb = isApprove ? 'Schváliť' : 'Zamietnuť'

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={`${verb} Change Order`}
      subtitle={isApprove
        ? 'Schválením sa CO stáva platným — VV / cena zákazky sa adekvátne upraví'
        : 'Zamietnutím sa CO archivuje. Stará verzia ostane dohľadateľná (soft archív).'}
      footer={
        <>
          <BtnGhost onClick={onClose}>Zrušiť</BtnGhost>
          {isApprove
            ? <BtnAdd onClick={doDecide} disabled={saving}>{saving ? 'Ukladám…' : '✓ Schváliť'}</BtnAdd>
            : <BtnDanger onClick={doDecide} disabled={saving}>{saving ? 'Ukladám…' : '✗ Zamietnuť'}</BtnDanger>}
        </>
      }
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: SPACE.md }}>
        <div style={{ padding: SPACE.md, background: COLORS.bgSoft, borderRadius: RADIUS.md, border: `1px solid ${COLORS.line}` }}>
          <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginBottom: 4 }}>Change Order</div>
          <div style={{ fontWeight: TYPO.weights.bold, fontSize: TYPO.sizes.sm }}>{co.description}</div>
          <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginTop: 4 }}>
            Cenový dopad: <b style={{ color: co.amount_delta >= 0 ? COLORS.add : COLORS.remove }}>{co.amount_delta >= 0 ? '+' : ''}{SK.eur(co.amount_delta || 0)}</b>
          </div>
        </div>
        <Textarea label={`Dôvod ${isApprove ? 'schválenia' : 'zamietnutia'} (voliteľné)`} value={reason} onChange={setReason} rows={3} placeholder={isApprove ? 'napr. súhlas klienta, technologicky správne' : 'napr. nesúhlas klienta, mimo rozsahu ZoD'} />
      </div>
    </Modal>
  )
}

// ══════════════════════════════════════════════════════════════
// AUDIT TAB
// ══════════════════════════════════════════════════════════════
function AuditTab({ project, onParentReload }) {
  const toast = useToast()
  const [closeable, setCloseable] = useState(null)

  useEffect(() => {
    fetchAuthJSON(`/api/projects/${project.id}/can-close`)
      .then(setCloseable)
      .catch(e => toast.error(`Kontrola can-close zlyhala: ${e.message}`))
  }, [project.id])

  const [terminyAkcia, setTerminyAkcia] = useState(null)   // ukoncit_v1: Ukončiť / Otvoriť cez Termíny (23.2.A)
  const doClose = () => setTerminyAkcia('ukoncit')   // ukončenie ide cez Termíny (dátum, RD vklad, zmenové listy)

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: SPACE.md }}>
      <TerminyAkciaOkno project={project} akcia={terminyAkcia || 'ukoncit'} open={!!terminyAkcia} onClose={() => setTerminyAkcia(null)} onChanged={() => onParentReload?.()} />
      {/* Časové údaje */}
      <div>
        <h3 style={{ margin: 0, marginBottom: SPACE.sm, fontSize: TYPO.sizes.md, fontWeight: TYPO.weights.bold }}>História záznamu</h3>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: TYPO.sizes.sm }}>
          <tbody>
            <tr style={{ borderBottom: `1px solid ${COLORS.lineSoft}` }}>
              <td style={{ padding: '6px 8px', color: COLORS.muted, width: 180 }}>ID</td>
              <td style={{ padding: '6px 8px', fontFamily: TYPO.mono }}>{project.id}</td>
            </tr>
            <tr style={{ borderBottom: `1px solid ${COLORS.lineSoft}` }}>
              <td style={{ padding: '6px 8px', color: COLORS.muted }}>Vytvorená</td>
              <td style={{ padding: '6px 8px' }}>{project.created_at || '—'}</td>
            </tr>
            <tr style={{ borderBottom: `1px solid ${COLORS.lineSoft}` }}>
              <td style={{ padding: '6px 8px', color: COLORS.muted }}>Posledná zmena</td>
              <td style={{ padding: '6px 8px' }}>{project.updated_at || '—'}</td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Kto čo zmenil — server píše rozdiel polí pri každom PUT /api/projects/:id (prava_v1, ústava 3.S.1 bod 3) */}
      <div>
        <h3 style={{ margin: 0, marginBottom: SPACE.sm, fontSize: TYPO.sizes.md, fontWeight: TYPO.weights.bold }}>Kto čo zmenil</h3>
        <HistoryPanel module="zakazka" entityId={project.id} />
      </div>

      {/* Akcie — status workflow */}
      <div>
        <h3 style={{ margin: 0, marginBottom: SPACE.sm, fontSize: TYPO.sizes.md, fontWeight: TYPO.weights.bold }}>Workflow statusu</h3>
        <div style={{ padding: SPACE.md, background: COLORS.bgSoft, borderRadius: RADIUS.md, fontSize: TYPO.sizes.sm }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: SPACE.sm, flexWrap: 'wrap' }}>
            <span>Dohodnuté</span>
            <span style={{ color: COLORS.muted }}>→</span>
            <span>Prebieha</span>
            <span style={{ color: COLORS.muted }}>→</span>
            <span>Ukončené</span>
          </div>
          <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginBottom: SPACE.md }}>
            Status prepneš cez "Upraviť" (políčko Stav). Ukončenie zákazky cez tlačidlo nižšie kontroluje neschválené Change Orders.
          </div>

          {project.status === 'done' ? (
            <div style={{ padding: SPACE.sm, background: COLORS.removeBg, borderRadius: RADIUS.sm, color: COLORS.remove, fontWeight: TYPO.weights.semibold }}>
              Zákazka je ukončená. <a onClick={() => setTerminyAkcia('otvorit')} style={{ color: COLORS.nav || '#2563eb', cursor: 'pointer', marginLeft: 8 }}>Otvoriť (Prebieha)</a>
            </div>
          ) : closeable ? (
            closeable.canClose ? (
              <BtnDanger onClick={doClose}>Ukončiť zákazku</BtnDanger>
            ) : (
              <div style={{ padding: SPACE.sm, background: 'rgba(245,158,11,0.12)', border: `1px solid ${COLORS.total}`, borderRadius: RADIUS.sm }}>
                <div style={{ color: COLORS.total, fontWeight: TYPO.weights.semibold, fontSize: TYPO.sizes.sm }}>
                  Nedá sa ukončiť
                </div>
                <div style={{ color: COLORS.muted, fontSize: TYPO.sizes.xs, marginTop: 2 }}>
                  {closeable.reason}
                </div>
              </div>
            )
          ) : (
            <div style={{ color: COLORS.muted, fontSize: TYPO.sizes.xs }}>Kontrolujem…</div>
          )}
        </div>
      </div>

      {/* MKsoft prepojenie */}
      {project.mksoft_cislo && (
        <div style={{ padding: SPACE.md, background: COLORS.bgSoft, borderRadius: RADIUS.md }}>
          <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginBottom: 4 }}>MKsoft synchronizácia</div>
          <div style={{ fontSize: TYPO.sizes.sm }}>
            MKsoft číslo: <b style={{ fontFamily: TYPO.mono }}>{project.mksoft_cislo}</b>
          </div>
          <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginTop: 2 }}>
            Sync z MKsoft Firebird DB (SKLAD_2026.FDB) — sek. 7
          </div>
        </div>
      )}
    </div>
  )
}

// Default export pre dispatch routing (priame /projects/:id)
export default function ProjectDetail() {
  // V Matrix v2 sa nevolá standalone — vždy cez DetailPane v master-detail.
  // Zatial placeholder; ak nieo standalone potrebuje, doplníme.
  return null
}


// ── FotkyTab — Foto-prílohy zákazky (sek. 59) ────────────────────────
function FotkyTab({ project }) {
  // Fotky zákazky: jedna galéria (Fotky + Denník + Závady), priečinky, pohľady (Mirko 24. 9. 2026)
  if (!project) return null
  return <FotkyZakazky project={project} />
}


// ── ZodTab — Zmluvy o dielo & prílohy (Mirko nahráva, nevytvára) ─────
function ZodTab({ project }) {
  if (!project) return null
  return (
    <div style={{ padding: 16 }}>
      <div style={{
        padding: 12, marginBottom: 16,
        background: 'rgba(59,130,246,0.06)',
        border: '1px solid rgba(59,130,246,0.3)',
        borderRadius: 6, fontSize: 13,
      }}>
        <strong>Zmluva o dielo (ZoD)</strong> — sem nahraj podpísanú ZoD, dodatky, vzájomné dohody.
        Matrix zmluvy <strong>negeneruje</strong> — len ich uchováva pri zákazke ako prílohu.
      </div>
      <AttachmentsPanel entityType="project_contract" entityId={project.id} />
    </div>
  )
}

